import api from '../../api'
import maps_api from '../../maps_api'
import moment from 'moment'

import {
    CREATE_NEW_APPRAISAL,
    DELETE_APPRAISAL,
    RESET_APPRAISAL,
    SET_APPRAISAL,
    SET_APPRAISAL_ID,
    SET_APPRAISAL_DATE_CREATED,
    SET_APPRAISAL_DATE_MODIFIED,
    SET_APPRAISAL_DIRTYNESS,
    SET_APPRAISAL_PARENT_PATH,
    SET_APPRAISAL_PATH,
    UPDATE_APPRAISAL,
    SET_APPRAISAL_APPRAISALDATE,
    SET_APPRAISAL_VISITDATE,
    SET_APPRAISAL_TECHNICIAN_VISITING,
    SET_APPRAISAL_DESCRIPTION,
    SET_APPRAISAL_PURPOSE,
    SET_APPRAISAL_PURPOSE_NOTES,
    SET_APPRAISAL_TYPE,
    SET_APPRAISAL_CHECKS_CADASTRAL_DATA,
    SET_APPRAISAL_CHECKS_CONSERVATION_STATUS,
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE,
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN,
    SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING,
    SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE,
    SET_APPRAISAL_CHECKS_INTERIOR_VISIT,
    SET_APPRAISAL_CHECKS_OCCUPANCY,
    SET_APPRAISAL_CHECKS_OTHER,
    SET_APPRAISAL_CHECKS_REGISTRY_DATA,
    SET_APPRAISAL_CHECKS_SERVITUDES,
    SET_APPRAISAL_CHECKS_SUBSIDY_STATUS,
    SET_APPRAISAL_CHECKS_URBAN_PLANNING,
    SET_APPRAISAL_DOCS_APPROVED_PROJECT,
    SET_APPRAISAL_DOCS_CADASTRAL_DATA,
    SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE,
    SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE,
    SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT,
    SET_APPRAISAL_DOCS_OCCUPANCY_STATUS,
    SET_APPRAISAL_DOCS_OTHER,
    SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT,
    SET_APPRAISAL_DOCS_PROPERTY_SKETCH,
    SET_APPRAISAL_DOCS_PROPERTY_TITLES,
    SET_APPRAISAL_DOCS_SITUATION_PLAN,
    SET_APPRAISAL_DOCS_SUBSIDY_STATUS,
    SET_APPRAISAL_DOCS_TENYEAR_INSURANCE,
    SET_APPRAISAL_DOCS_URBAN_PLAN,
    SET_APPRAISAL_ADOPTED_AREA,
    SET_APPRAISAL_LIFT,
    SET_APPRAISAL_ADOPTED_AGE,
    SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD,
    SET_APPRAISAL_PROPERTY_TYPE,
    SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD,
    SET_APPRAISAL_QUALITY_OF_SITUATION,
    SET_APPRAISAL_QUALITY_OF_CONSTRUCTION,
    SET_APPRAISAL_QUALITY_OF_REALESTATE,
    SET_APPRAISAL_CONSERVATION_STATUS,
    SET_APPRAISAL_FLOOR_NUMBER,
    SET_APPRAISAL_MARKET_VALUE,
    SET_APPRAISAL_MARKET_UNIT_VALUE,
    SET_APPRAISAL_BEC_PRICE,
    SET_APPRAISAL_ADJUSTED_BEC_PRICE,
    SET_APPRAISAL_BC,
    SET_APPRAISAL_BC_PCT,
    SET_APPRAISAL_GC,
    SET_APPRAISAL_GC_PCT,
    SET_APPRAISAL_BC_AND_GC_PCT,
    SET_APPRAISAL_BC_AND_GC,
    SET_APPRAISAL_CC,
    SET_APPRAISAL_CC_PCT,
    SET_APPRAISAL_HTL,
    SET_APPRAISAL_HTL_PCT,
    SET_APPRAISAL_INR,
    SET_APPRAISAL_INR_PCT,
    SET_APPRAISAL_GA,
    SET_APPRAISAL_GA_PCT,
    SET_APPRAISAL_GPD,
    SET_APPRAISAL_GPD_PCT,
    SET_APPRAISAL_OCT,
    SET_APPRAISAL_OCT_PCT,
    SET_APPRAISAL_GP,
    SET_APPRAISAL_GP_PCT,
    SET_APPRAISAL_CC_AND_GP,
    SET_APPRAISAL_F,
    SET_APPRAISAL_CRB,
    SET_APPRAISAL_CCD,
    SET_APPRAISAL_TLR_PCT,
    SET_APPRAISAL_PR_PCT,
    SET_APPRAISAL_AM_COEF,
    SET_APPRAISAL_B1_PCT,
    SET_APPRAISAL_B2_PCT,
    SET_APPRAISAL_B_PCT,
    SET_APPRAISAL_B_REMAINING_PCT,
    SET_APPRAISAL_I_PCT,
    SET_APPRAISAL_TENANT_AGE_YEARS,
    SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS,
    SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS,
    SET_APPRAISAL_CESSION_BOOLEAN,
    SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME,
    SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME,
    SET_APPRAISAL_CESSION_NET_YEARLY_INCOME,
    SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS,
    SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS,
    SET_APPRAISAL_CESSION_CONTRACT_START_DATE,
    SET_APPRAISAL_LANDLORD_EXPENSES_PCT,
    SET_APPRAISAL_REDUCTION_PCT,
    SET_APPRAISAL_ADJUSTMENT_COEF,
    SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS,
    SET_APPRAISAL_USEFUL_LIFE_YEARS,
    SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS,
    SET_APPRAISAL_MAX_LEGAL_PRICE,
    SET_APPRAISAL_MAX_LEGAL_AREA,
    SET_APPRAISAL_MATERIAL_EXECUTION_COST,
    SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST,
    SET_APPRAISAL_MEC_ADJUSTMENT_COEF,
    SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST,
    SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT,
    SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT,
    SET_APPRAISAL_TOTAL_DEPRECIATION_PCT,
    SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT,
    SET_APPRAISAL_ADOPTED_MARKET_VALUE,
    SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE,
    SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT,
    SET_APPRAISAL_DEPRECATED_LAND_AND_CC,
    SET_APPRAISAL_FINISHED_REALESTATE_CRN,
    SET_APPRAISAL_CCR,
    SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST,
    SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN,
    SET_APPRAISAL_K,
    SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE,
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE,
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE,
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE,
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE,
    SET_APPRAISAL_COMPARISON_METHOD,
    SET_APPRAISAL_ADJUSTED_MARKET_VALUE,
    SET_APPRAISAL_MAX_LEGAL_METHOD,
    SET_APPRAISAL_VC,
    SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD,
    SET_APPRAISAL_U,
    SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT,
    SET_APPRAISAL_RESIDUAL_DEPRECIATION,
    SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE,
    SET_APPRAISAL_I,
    SET_APPRAISAL_NP,
    SET_APPRAISAL_COEF_1,
    SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE,
    SET_APPRAISAL_COEF_2,
    SET_APPRAISAL_UPDATED_REVERSION_VALUE,
    SET_APPRAISAL_UPDATE_VALUE,
    SET_APPRAISAL_INSURANCE_VALUE,
    SET_APPRAISAL_VU_COEF,
    SET_APPRAISAL_USUFRUCT_VALUE,
    SET_APPRAISAL_BARE_OWNERSHIP_VALUE,
    SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE,
    SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD,
    SET_APPRAISAL_REALESTATE_ID,
    SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN,
    SET_APPRAISAL_PROTECTION_BOOLEAN,
    SET_APPRAISAL_PROTECTION_TYPE,
    SET_APPRAISAL_PROTECTION_REGIME,
    SET_APPRAISAL_PROTECTION_ZONE,
    SET_APPRAISAL_URBAN_PLANNING_TYPE,
    SET_APPRAISAL_URBAN_PLANNING_FILE,
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION,
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION,
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION,
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION,
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION,
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION,
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION,
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION,
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS,
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL,
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO,
    SET_APPRAISAL_LAND_REGISTRY_AREA,
    SET_APPRAISAL_LAND_CADASTRAL_AREA,
    SET_APPRAISAL_LAND_CHECKED_AREA,
    SET_APPRAISAL_LAND_ADOPTED_AREA,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS,
    SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW,
    SET_APPRAISAL_LAND_AREA_NOTES,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT,
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY,
    SET_APPRAISAL_PLOT_OCCUPATION,
    SET_APPRAISAL_PLOT_FREE_AREA_USAGE,
    SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND,
    SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND,
    SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER,
    SET_APPRAISAL_ENTRANCE_HALL,
    SET_APPRAISAL_DOORMAN_SPACE,
    SET_APPRAISAL_STAIRCASE,
    SET_APPRAISAL_SWIMMING_POOL,
    SET_APPRAISAL_GARDENED_AREAS,
    SET_APPRAISAL_SPORTS_FACILITIES,
    SET_APPRAISAL_COMMUNITY_ROOM,
    SET_APPRAISAL_STORAGE_ROOM,
    SET_APPRAISAL_COMMUNITY_PARKING,
    SET_APPRAISAL_FACILITIES_OTHERS,
    SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND,
    SET_APPRAISAL_FLOORS_USAGE_OVERGROUND,
    SET_APPRAISAL_GROUNDFLOOR_USAGE,
    SET_APPRAISAL_COMMUNICATIONS_AIRPORT,
    SET_APPRAISAL_COMMUNICATIONS_HARBOUR,
    SET_APPRAISAL_COMMUNICATIONS_TRAIN,
    SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND,
    SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN,
    SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES,
    SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE,
    SET_APPRAISAL_SURROUNDING_INCOME_LEVEL,
    SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE,
    SET_APPRAISAL_SURROUNDING_MAIN_USES,
    SET_APPRAISAL_SURROUNDING_DENSITY,
    SET_APPRAISAL_SURROUNDING_ACCESSIBILITY,
    SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE,
    SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE,
    SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED,
    SET_APPRAISAL_SURROUNDING_AVERAGE_AGE,
    SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS,
    SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES,
    SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES,
    SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING,
    SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE,
    SET_APPRAISAL_SURROUNDING_LEISURE,
    SET_APPRAISAL_CADASTRAL_USAGE,
    SET_APPRAISAL_CADASTRAL_FLOOR,
    SET_APPRAISAL_CADASTRAL_DOOR,
    SET_APPRAISAL_CADASTRAL_BLOCK,
    SET_APPRAISAL_CADASTRAL_STAIRCASE,
    SET_APPRAISAL_REGISTRY_NAME,
    SET_APPRAISAL_REGISTRY_SECTION,
    SET_APPRAISAL_REGISTRY_VOLUME,
    SET_APPRAISAL_REGISTRY_BOOK,
    SET_APPRAISAL_REGISTRY_PAGE,
    SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER,
    SET_APPRAISAL_REGISTRY_IDUFIR,
    SET_APPRAISAL_REGISTRY_OWNER,
    SET_APPRAISAL_REGISTRY_PROPERTY_COEF,
    SET_APPRAISAL_NET_CADASTRAL_AREA,
    SET_APPRAISAL_NET_REGISTRY_AREA,
    SET_APPRAISAL_NET_CHECKED_AREA,
    SET_APPRAISAL_NET_ADOPTED_AREA,
    SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA,
    SET_APPRAISAL_ENCLOSED_REGISTRY_AREA,
    SET_APPRAISAL_ENCLOSED_CHECKED_AREA,
    SET_APPRAISAL_ENCLOSED_ADOPTED_AREA,
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA,
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA,
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA,
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA,
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA,
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA,
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA,
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA,
    SET_APPRAISAL_BUILT_CADASTRAL_AREA,
    SET_APPRAISAL_BUILT_REGISTRY_AREA,
    SET_APPRAISAL_BUILT_CHECKED_AREA,
    SET_APPRAISAL_BUILT_ADOPTED_AREA,
    SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA,
    SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA,
    SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA,
    SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA,
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA,
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA,
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA,
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA,
    SET_APPRAISAL_BATHROOMS_NUMBER,
    SET_APPRAISAL_BEDROOMS_NUMBER,
    SET_APPRAISAL_NET_SELECTED_AREA,
    SET_APPRAISAL_ENCLOSED_SELECTED_AREA,
    SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA,
    SET_APPRAISAL_BUILT_SELECTED_AREA,
    SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA,
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA,
    SET_APPRAISAL_LAND_SELECTED_AREA,
    SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER,
    SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING,
    SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER,
    SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS,
    SET_APPRAISAL_REALESTATE_SYSTEMS_GAS,
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS,
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS,
    SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER,
    SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING,
    SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING,
    SET_APPRAISAL_REALESTATE_SYSTEMS_TV,
    SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE,
    SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION,
    SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION,
    SET_APPRAISAL_REALESTATE_FOUNDATION,
    SET_APPRAISAL_REALESTATE_STRUCTURE,
    SET_APPRAISAL_REALESTATE_ROOF,
    SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES,
    SET_APPRAISAL_REALESTATE_INSULATION,
    SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY,
    SET_APPRAISAL_REALESTATE_GLAZING,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM,
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY,
    SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION,
    SET_APPRAISAL_REALESTATE_MAIN_VIEWS,
    SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY,
    SET_APPRAISAL_REALESTATE_NOISE_FACADE,
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY,
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY,
    SET_APPRAISAL_BEC_ADJUSTMENT_COEF,
    SET_APPRAISAL_BEC_PROPERTY_TYPE,
    SET_APPRAISAL_BEC_NUMBER,
    SET_APPRAISAL_CONSTRUCTION_STATUS,
    SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT,
    SET_APPRAISAL_CONSTRUCTION_COST_NOTES,
    SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR,
    SET_APPRAISAL_CONSTRUCTION_YEAR,
    SET_APPRAISAL_LAST_RENOVATION_YEAR,
    SET_APPRAISAL_NUCLEUS_POPULATION,
    SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY,
    SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH,
    SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT,
    SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT,
    SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT,
    SET_APPRAISAL_OCCUPATION_SERVICES_PCT,
    SET_APPRAISAL_OCCUPATION_TOTAL_PCT,
    SET_APPRAISAL_NUCLEUS_TYPE,
    SET_APPRAISAL_OCCUPATION_DESCRIPTION,
    SET_APPRAISAL_NUCLEUS_AREA,
    SET_APPRAISAL_PROPERTY_TITLE,
    SET_APPRAISAL_USAGE_ASSIGNED,
    SET_APPRAISAL_INSPECTION_REALIZED,
    SET_APPRAISAL_ECONOMICAL_ACTIVITY,
    SET_APPRAISAL_OCCUPANCY_STATUS,
    SET_APPRAISAL_MARKETSTUDY_ID,
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X,
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y,
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM,
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X,
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y,
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM,
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X,
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y,
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM,
    SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS,
    SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS,
    SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR,
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY,
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS,
    SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES,
    SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE,
    SET_APPRAISAL_QUOTE_BASE_FEES,
    SET_APPRAISAL_QUOTE_EXCESS_PCT,
    SET_APPRAISAL_QUOTE_BASE_PRICE,
    SET_APPRAISAL_QUOTE_BASE_PRICE_COEF,
    SET_APPRAISAL_USAGE_TYPE,
    SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER,

} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    appraisaldate: null,
    visitdate: null,
    technician_visiting: null,
    description: null,
    checks_cadastral_data: true,
    checks_conservation_status: true,
    checks_expropriation_procedure: true,
    checks_expropriation_plan: true,
    checks_expropriation_admin_ruling: true,
    checks_expropriation_file: true,
    checks_interior_visit: true,
    checks_occupancy: true,
    checks_other: null,
    checks_registry_data: true,
    checks_servitudes: true,
    checks_subsidy_status: true,
    checks_urban_planning: true,
    docs_approved_project: true,
    docs_cadastral_data: true,
    docs_construction_license: true,
    docs_construction_last_certificate: true,
    docs_construction_contract: true,
    docs_occupancy_status: true,
    docs_other: null,
    docs_photographic_report: true,
    docs_property_sketch: true,
    docs_property_titles: true,
    docs_situation_plan: true,
    docs_subsidy_status: true,
    docs_tenyear_insurance: true,
    docs_urban_plan: true,
    purpose: {
        acc_eco_decree: {id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        acc_mortgage_market_law: {id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        bde_code: 'O',
        id: 5,
        name_ca: 'Adquisició o venda',
        name_en: 'Purchase or sale',
        name_es: 'Adquisición o venta',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
        },
        default_reduction_pct: 0
    },
    purpose_notes: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
    type: {
        bde_code: 'C',
        id: 1,
        name_ca: 'Taxació completa',
        name_en: 'Complete Valuation',
        name_es: 'Tasación Completa'
    },
    adopted_area: null,
    lift: null,
    adopted_age: null,
    adopted_age_years_old: null,
    property_type: null,
    quality_of_neighbourhood: null,
    quality_of_situation: null,
    quality_of_construction: null,
    quality_of_realestate: null,
    conservation_status: null,
    floor_number: null,
    market_value: null,
    market_unit_value: null,
    bec_price: null,
    adjusted_bec_price: null,
    bc: null,
    bc_pct: null,
    gc: null,
    gc_pct: null,
    bc_and_gc_pct: null,
    bc_and_gc: null,
    cc: null,
    cc_pct: null,
    htl: null,
    htl_pct: null,
    inr: null,
    inr_pct: null,
    ga: null,
    ga_pct: null,
    gpd: null,
    gpd_pct: null,
    oct: null,
    oct_pct: null,
    gp: null,
    gp_pct: null,
    cc_and_gp: null,
    f: null,
    crb: null,
    ccd: null,
    tlr_pct: null,
    pr_pct: null,
    am_coef: null,
    b1_pct: null,
    b2_pct: null,
    b_pct: null,
    b_remaining_pct: null,
    i_pct: null,
    tenant_age_years: 35,
    tenant_life_expectancy_years: 83,
    tenant_remaining_life_expectancy_years: 48,
    cession_boolean: null,
    cession_gross_monthly_income: null,
    cession_gross_yearly_income: null,
    cession_net_yearly_income: null,
    cession_contract_period_years: null,
    cession_contract_remaining_years: null,
    cession_contract_start_date: null,
    landlord_expenses_pct: 70,
    reduction_pct: null,
    adjustment_coef: null,
    usufructuary_age_years: null,
    useful_life_years: null,
    remaining_useful_life_years: null,
    max_legal_price: null,
    max_legal_area: null,
    material_execution_cost: null,
    deprecated_material_execution_cost: null,
    mec_adjustment_coef: 1,
    adopted_material_execution_cost: null,
    physical_depreciation_pct: null,
    functional_depreciation_pct: null,
    total_depreciation_pct: null,
    total_construction_progress_pct: 100,
    adopted_market_value: null,
    adopted_market_unit_value: null,
    market_value_appraiser_adjustment_pct: null,
    deprecated_land_and_cc: null,
    finished_realestate_crn: null,
    ccr: null,
    executed_construction_cost: null,
    under_construction_realestate_crn: null,
    k: null,
    repercussion_method_land_value: null,
    cost_method_construction_crb_value: null,
    cost_method_construction_crn_value: null,
    cost_method_realestate_crb_value: null,
    cost_method_realestate_crn_value: null,
    comparison_method: null,
    adjusted_market_value: null,
    max_legal_method: null,
    vc: null,
    income_perpetuity_update_method: null,
    u: null,
    residual_depreciation_pct: null,
    residual_depreciation: null,
    realestate_residual_value: null,
    i: null,
    np: null,
    coef_1: null,
    current_future_income_value: null,
    coef_2: null,
    updated_reversion_value: null,
    update_value: null,
    insurance_value: null,
    vu_coef: null,
    usufruct_value: null,
    bare_ownership_value: null,
    realestate_total_adopted_value: null,
    realestate_adopted_appraisal_method: null,
    realestate_id: null,
    right_of_use_boolean: null,
    protection_boolean: null,
    protection_type: null,
    protection_regime: null,
    protection_zone: null,
    urban_planning_type: null,
    urban_planning_file: null,
    urban_planning_council_qualification: null,
    urban_planning_council_qualification_description: null,
    urban_planning_council_classification: null,
    urban_planning_council_classification_description: null,
    urban_planning_regional_qualification: null,
    urban_planning_regional_qualification_description: null,
    urban_planning_regional_classification: null,
    urban_planning_regional_classification_description: null,
    map_urban_muc_land_colors: null,
    map_urban_muc_council_qual: null,
    map_urban_icc_topo: null,
    land_registry_area: null,
    land_cadastral_area: null,
    land_checked_area: null,
    land_adopted_area: null,
    land_infrastructure_paving_execution_pct: 100,
    land_infrastructure_sewage_execution_pct: 100,
    land_infrastructure_public_lighting_execution_pct: 100,
    land_infrastructure_electricity_supply_execution_pct: 100,
    land_infrastructure_piped_gas_execution_pct: 100,
    land_infrastructure_telephone_service_execution_pct: 100,
    land_infrastructure_gardened_areas_execution_pct: 100,
    land_infrastructure_total_execution_pct: 100,
    land_infrastructure_repercussion_cost: 150,
    land_infrastructure_pending_investment: 0,
    land_infrastructure_paving: true,
    land_infrastructure_sewage: true,
    land_infrastructure_public_lighting: true,
    land_infrastructure_electricity_supply: true,
    land_infrastructure_piped_gas: true,
    land_infrastructure_telephone_service: true,
    land_infrastructure_gardened_areas: true,
    land_is_plot_according_to_law: true,
    land_area_notes: null,
    land_infrastructure_notes: null,
    land_infrastructure_conservation_status: {
        id: 2,
        code_bde: 2,
        name_ca: 'Bona',
        name_en: 'Good',
        name_es: 'Buena',
    },
    land_infrastructure_water_supply_execution_pct: 100,
    land_infrastructure_water_supply: true,
    plot_occupation: null,
    plot_free_area_usage: null,
    floors_number_underground: null,
    floors_number_overground: null,
    parking_slots_included_in_appraisal_number: null,
    entrance_hall: null,
    doorman_space: null,
    staircase: null,
    swimming_pool: null,
    gardened_areas: null,
    sports_facilities: null,
    community_room: null,
    storage_room: null,
    community_parking: null,
    facilities_others: null,
    floors_usage_underground: null,
    floors_usage_overground: null,
    groundfloor_usage: null,
    communications_airport: null,
    communications_harbour: null,
    communications_train: null,
    public_transport_urban_underground: null,
    public_transport_interurban: null,
    surrounding_facilities_notes: null,
    surrounding_territorial_feature: null,
    surrounding_income_level: null,
    surrounding_homogeneity_feature: null,
    surrounding_main_uses: null,
    surrounding_density: null,
    surrounding_accessibility: null,
    surrounding_consolidation_degree: null,
    surrounding_occupation_degree: null,
    surrounding_evolution_speed: null,
    surrounding_average_age: null,
    surrounding_conservation_status: null,
    surrounding_commercial_facilities: null,
    surrounding_educational_facilities: null,
    surrounding_public_parking: null,
    surrounding_medical_assistance: null,
    surrounding_leisure: null,
    cadastral_usage: null,
    cadastral_floor: null,
    cadastral_door: null,
    cadastral_block: null,
    cadastral_staircase: null,
    registry_name: null,
    registry_section: null,
    registry_volume: null,
    registry_book: null,
    registry_page: null,
    registry_real_estate_number: null,
    registry_idufir: null,
    registry_owner: null,
    registry_property_coef: null,
    net_cadastral_area: null,
    net_registry_area: null,
    net_checked_area: null,
    net_adopted_area: null,
    enclosed_cadastral_area: null,
    enclosed_registry_area: null,
    enclosed_checked_area: null,
    enclosed_adopted_area: null,
    covered_terraces_total_cadastral_area: null,
    covered_terraces_total_registry_area: null,
    covered_terraces_total_checked_area: null,
    covered_terraces_total_adopted_area: null,
    uncovered_terraces_total_cadastral_area: null,
    uncovered_terraces_total_registry_area: null,
    uncovered_terraces_total_checked_area: null,
    uncovered_terraces_total_adopted_area: null,
    built_cadastral_area: null,
    built_registry_area: null,
    built_checked_area: null,
    built_adopted_area: null,
    common_elements_cadastral_area: null,
    common_elements_registry_area: null,
    common_elements_checked_area: null,
    common_elements_adopted_area: null,
    built_plus_common_elements_cadastral_area: null,
    built_plus_common_elements_registry_area: null,
    built_plus_common_elements_checked_area: null,
    built_plus_common_elements_adopted_area: null,
    bathrooms_number: null,
    bedrooms_number: null,
    net_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    enclosed_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    covered_outdoors_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    built_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    common_elements_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    built_plus_common_elements_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    land_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    realestate_rooms_to_exterior_number: null,
    realestate_day_night_zoning: null,
    realestate_systems_door_opener: null,
    realestate_systems_fitted_cupboards: null,
    realestate_systems_gas: null,
    realestate_systems_sanitary_fittings: null,
    realestate_systems_taps: null,
    realestate_systems_hot_water: null,
    realestate_systems_heating: null,
    realestate_systems_air_conditioning: null,
    realestate_systems_tv: null,
    realestate_systems_telephone: null,
    realestate_systems_fire_prevention: null,
    realestate_systems_intrusion_prevention: null,
    realestate_foundation: null,
    realestate_structure: null,
    realestate_roof: null,
    realestate_external_enclosures: null,
    realestate_insulation: null,
    realestate_external_carpentry: null,
    realestate_glazing: null,
    realestate_interior_paving_living: null,
    realestate_interior_paving_corridor: null,
    realestate_interior_paving_bedroom: null,
    realestate_interior_paving_kitchen: null,
    realestate_interior_paving_bathroom: null,
    realestate_interior_paving_quality: null,
    realestate_interior_walls_living: null,
    realestate_interior_walls_corridor: null,
    realestate_interior_walls_bedroom: null,
    realestate_interior_walls_kitchen: null,
    realestate_interior_walls_bathroom: null,
    realestate_interior_walls_quality: null,
    realestate_interior_ceilings_living: null,
    realestate_interior_ceilings_corridor: null,
    realestate_interior_ceilings_bedroom: null,
    realestate_interior_ceilings_kitchen: null,
    realestate_interior_ceilings_bathroom: null,
    realestate_interior_ceilings_quality: null,
    realestate_interior_carpentry_living: null,
    realestate_interior_carpentry_corridor: null,
    realestate_interior_carpentry_bedroom: null,
    realestate_interior_carpentry_kitchen: null,
    realestate_interior_carpentry_bathroom: null,
    realestate_interior_carpentry_quality: null,
    realestate_main_orientation: null,
    realestate_main_views: null,
    realestate_windows_size_and_quantity: null,
    realestate_noise_facade: null,
    realestate_systems_sanitary_fittings_quality: null,
    realestate_systems_taps_quality: null,
    bec_adjustment_coef: 1,
    bec_property_type: null,
    bec_number: null,
    construction_status: {
        id: 1,
        name_ca: 'Acabat',
        name_es: 'Terminado',
        name_en: 'Finished',
        code_bde: 'U00'
    },
    expenses_and_industrial_benefit_bec_pct: 20,
    construction_cost_notes: null,
    cadastral_construction_year: null,
    construction_year: null,
    last_renovation_year: null,
    nucleus_population: null,
    nucleus_population_density: null,
    nucleus_population_growth: null,
    occupation_agriculture_pct: null,
    occupation_industry_pct: null,
    occupation_construction_pct: null,
    occupation_services_pct: null,
    occupation_total_pct: null,
    nucleus_type: null,
    occupation_description: null,
    nucleus_area: null,
    property_title: null,
    usage_assigned: null,
    inspection_realized: null,
    economical_activity: null,
    occupancy_status: null,
    marketstudy_id: null,
    parking_spots_included_number: null,
    notes: {
        note_001: {
            name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
            name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
            name_en: ''
        },
        note_002: {
            name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
            name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
            name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
        },
        note_003: {
            name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
            name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
        },
        note_004: {
            name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
            name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
            name_en: 'Both BARNA-Charges, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
        },
        note_005: {
            name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
            name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
            name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
        },
        note_006: {
            name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
            name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
            name_en: 'The valuation has been made considering the property is free of charges and liens'
        }
    },
    map_urban_muc_land_colors_offset_x: 0,
    map_urban_muc_land_colors_offset_y: 0,
    map_urban_muc_land_colors_zoom: 1,
    map_urban_muc_council_qual_offset_x: 0,
    map_urban_muc_council_qual_offset_y: 0,
    map_urban_muc_council_qual_zoom: 1,
    map_urban_icc_topo_offset_x: 0,
    map_urban_icc_topo_offset_y: 0,
    map_urban_icc_topo_zoom: 1,
    quote_travel_one_way_hours: 0,
    quote_travel_both_ways_hours: 0,
    quote_travel_fees_per_hour: 20,
    quote_car_expenses_one_way: 0,
    quote_car_expenses_both_ways: 0,
    quote_total_travel_fees: 0,
    quote_area_average_unit_price: null,
    quote_base_fees: null,
    quote_excess_pct: null,
    quote_base_price: null,
    quote_base_price_coef: 1,
    usage_type: null,

}

const state = default_state

const actions = {

    CREATE_NEW_APPRAISAL: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key

                    const default_appraisaldate = moment(res.date_created, 'x').format('YYYY-MM-DD')

                    commit(SET_APPRAISAL_ID, new_created_key)
                    commit(SET_APPRAISAL_DATE_CREATED, res.date_created)
                    commit(SET_APPRAISAL_DATE_MODIFIED, res.date_modified)
                    commit(SET_APPRAISAL_APPRAISALDATE, default_appraisaldate)
                    commit(SET_APPRAISAL_PARENT_PATH, data.parent_path)
                    commit(SET_APPRAISAL_PATH, res.path)
                    commit(SET_APPRAISAL_REALESTATE_ID, data.realestate_id)

                    api.set_value({
                        value: default_appraisaldate,
                        path: data.path + new_created_key + '/' + 'appraisaldate',
                        save_timestamp: false
                    }).then((res) => {
                        api.set_value({
                            value: data.realestate_id,
                            path: data.path + new_created_key + '/' + 'realestate_id',
                            save_timestamp: false
                        }).then((res) => {
                            api.set_value({
                                value: new_created_key,
                                path: data.path + new_created_key + '/' + 'id',
                                save_timestamp: false
                            }).then((res) => {
                                const object = {}
                                object[new_created_key] = true
                                api.update({
                                    object: object,
                                    path: data.parent_path,
                                    save_timestamp: false
                                }).then(res => resolve({key: new_created_key}))
                            })
                        })
                    })
                })

        })
    },
    DELETE_APPRAISAL: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_appraisals/contact_key
            api.delete({key: data.key, path: data.path})
                .then((res) => {
                    // delete from contact/contact_key/appraisals
                    api.delete({key: data.key, path: data.parent_path})
                        .then((res) => {
                            commit(RESET_APPRAISAL)

                        }).then(res => resolve({}))
                })

        })

    },
    FETCH_APPRAISAL: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then((res) => {
                    resolve(res)
                })
        })
    },
    SET_APPRAISAL: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {

            // console.log('set_appraisal data:')
            // console.log(data)
            return api.get({path: data.path})
                .then((res) => {
                    console.log(res)
                    commit(SET_APPRAISAL, res)
                }).then(res => resolve({}))

        })

    },
    RESET_APPRAISAL: ({state, commit, rootState}) => {
        commit(RESET_APPRAISAL)
    },
    REQUEST_IDESCAT_INFO_BY_CODE_INE: ({state, commit, rootState}, data) => {

        return maps_api.request_idescat_info_by_code_ine(data)
            .then((res) => {

                console.log('request_idescat_info_by_code_ine res:')
                console.log(res)

                let val_arr = []

                // 1: Població
                // 0: Densitat de població
                // 0: Superfície
                let nucleus_area = res['html']['fitxes']['gg']['g'][1]['tt']['t'][0]['ff']['f'][0]['v']
                val_arr = nucleus_area.split(',')
                nucleus_area = Number(val_arr[0])
                console.log('nucleus_area: ')
                console.log(nucleus_area)

                // 1: Població
                // 0: Densitat de població
                // 1: Densitat
                let nucleus_population_density = res['html']['fitxes']['gg']['g'][1]['tt']['t'][0]['ff']['f'][1]['v']
                val_arr = nucleus_population_density.split(',')
                nucleus_population_density = Number(val_arr[0])
                console.log('nucleus_population_density: ')
                console.log(nucleus_population_density)

                // 1: Població
                // 1: Població. Per sexe
                // 2: Total
                let nucleus_population = res['html']['fitxes']['gg']['g'][1]['tt']['t'][1]['ff']['f'][2]['v']
                val_arr = nucleus_population.split(',')
                nucleus_population = Number(val_arr[0])
                console.log('nucleus_population: ')
                console.log(nucleus_population)

                // 1: Població
                // 19: Creixement de la població
                // 4: Creixement total

                let nucleus_population_growth = null
                let nucleus_pre_19 = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19]
                let nucleus_pre_17 = res['html']['fitxes']['gg']['g'][1]['tt']['t'][17]


                if(nucleus_pre_19){
                    let nucleus_pre = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19]['ff']['f']
                    //nucleus_population_growth = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19]['ff']['f'][4]['v']

                    if(nucleus_pre){

                        _.forEach(nucleus_pre, function(value) {
                            if(value['c'] === 'Creixement total'){
                                nucleus_population_growth = value['v']
                                if (nucleus_population_growth) {
                                    val_arr = nucleus_population_growth.split(',')
                                    nucleus_population_growth = Number(val_arr[0])
                                    console.log('nucleus_population_growth: ')
                                    console.log(nucleus_population_growth)

                                }
                            }
                        })


                    }
                }else if(nucleus_pre_17){
                    let nucleus_pre = res['html']['fitxes']['gg']['g'][1]['tt']['t'][17]['ff']['f']

                    if(nucleus_pre){

                        _.forEach(nucleus_pre, function(value) {
                            if(value['c'] === 'Creixement total'){
                                nucleus_population_growth = value['v']
                                if (nucleus_population_growth) {
                                    val_arr = nucleus_population_growth.split(',')
                                    nucleus_population_growth = Number(val_arr[0])
                                    console.log('nucleus_population_growth: ')
                                    console.log(nucleus_population_growth)

                                }
                            }
                        })


                    }

                }else{

                }

                // 5: Treball
                // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
                // 0: Agricultura
                let occupation_general_agriculture = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][0]['v']
                val_arr = occupation_general_agriculture.split(',')
                occupation_general_agriculture = Number(val_arr[0])
                if(isNaN(occupation_general_agriculture)){
                    occupation_general_agriculture = 0
                }
                console.log('occupation_general_agriculture: ')
                console.log(occupation_general_agriculture)

                // 5: Treball
                // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
                // 1: Indústria
                let occupation_general_industry = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][1]['v']
                val_arr = occupation_general_industry.split(',')
                occupation_general_industry = Number(val_arr[0])
                if(isNaN(occupation_general_industry)){
                    occupation_general_industry = 0
                }
                console.log('occupation_general_industry: ')
                console.log(occupation_general_industry)

                // 5: Treball
                // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
                // 2: Construcció
                let occupation_general_construction = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][2]['v']
                val_arr = occupation_general_construction.split(',')
                occupation_general_construction = Number(val_arr[0])
                if(isNaN(occupation_general_construction)){
                    occupation_general_construction = 0
                }
                console.log('occupation_general_construction: ')
                console.log(occupation_general_construction)

                // 5: Treball
                // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
                // 3: Serveis
                let occupation_general_services = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][3]['v']
                val_arr = occupation_general_services.split(',')
                occupation_general_services = Number(val_arr[0])
                if(isNaN(occupation_general_services)){
                    occupation_general_services = 0
                }
                console.log('occupation_general_services: ')
                console.log(occupation_general_services)

                // 5: Treball
                // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
                // 4: Total
                let occupation_general_total = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][4]['v']
                val_arr = occupation_general_total.split(',')
                occupation_general_total = Number(val_arr[0])
                if(isNaN(occupation_general_total)){
                    occupation_general_total = 0
                }
                console.log('occupation_general_total: ')
                console.log(occupation_general_total)

                // 5: Treball
                // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
                // 0: Agricultura
                let occupation_freelance_agriculture = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][0]['v']
                val_arr = occupation_freelance_agriculture.split(',')
                occupation_freelance_agriculture = Number(val_arr[0])
                console.log('occupation_freelance_agriculture: ')
                console.log(occupation_freelance_agriculture)

                // 5: Treball
                // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
                // 1: Indústria
                let occupation_freelance_industry = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][1]['v']
                val_arr = occupation_freelance_industry.split(',')
                occupation_freelance_industry = Number(val_arr[0])
                console.log('occupation_freelance_industry: ')
                console.log(occupation_freelance_industry)

                // 5: Treball
                // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
                // 2: Construcció
                let occupation_freelance_construction = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][2]['v']
                val_arr = occupation_freelance_construction.split(',')
                occupation_freelance_construction = Number(val_arr[0])
                console.log('occupation_freelance_construction: ')
                console.log(occupation_freelance_construction)

                // 5: Treball
                // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
                // 3: Serveis

                let occupation_f_s_pre = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][3]
                let occupation_freelance_services = 0

                if (occupation_f_s_pre){
                    occupation_freelance_services = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][3]['v']
                    val_arr = occupation_freelance_services.split(',')
                    occupation_freelance_services = Number(val_arr[0])
                }else{

                }
                console.log('occupation_freelance_services: ')
                console.log(occupation_freelance_services)

                // 5: Treball
                // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
                // 4: Total
                let occupation_f_t_pre = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][4]
                let occupation_freelance_total = 0

                if(occupation_f_t_pre){
                    occupation_freelance_total = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][4]['v']
                    val_arr = occupation_freelance_total.split(',')
                    occupation_freelance_total = Number(val_arr[0])
                }else{

                }               
                console.log('occupation_freelance_total: ')
                console.log(occupation_freelance_total)

                let occupation_agriculture = occupation_general_agriculture + occupation_freelance_agriculture
                let occupation_industry = occupation_general_industry + occupation_freelance_industry
                let occupation_construction = occupation_general_construction + occupation_freelance_construction
                let occupation_services = occupation_general_services + occupation_freelance_services
                let occupation_total = occupation_general_total + occupation_freelance_total

                let occupation_agriculture_pct = roundToTwo((occupation_agriculture / occupation_total) * 100)
                let occupation_industry_pct = roundToTwo((occupation_industry / occupation_total) * 100)
                let occupation_construction_pct = roundToTwo((occupation_construction / occupation_total) * 100)
                let occupation_services_pct = roundToTwo((occupation_services / occupation_total) * 100)
                let occupation_total_pct = roundToTwo((occupation_total / occupation_total) * 100)

                /*
                let occupation_description = {
                    id: 1,
                    'name_ca': 'El ' + occupation_services_pct + '% de la població està ocupat al sector Serveis, el ' + occupation_industry_pct + '% al sector Indústria, ' + occupation_construction_pct + '% al sector de la Construcció i el ' + occupation_agriculture_pct + '% al sector Agricultura',
                    'name_en': 'The ' + occupation_services_pct + '% of the population is employed in the Services sector, the ' + occupation_industry_pct + '% in the Industry sector, ' + occupation_construction_pct + '% in the Construction sector and the ' + occupation_agriculture_pct + '% in the Agriculture sector',
                    'name_es': 'El ' + occupation_services_pct + '% de la población está ocupado en el sector Servicios, el ' + occupation_industry_pct + '% en el sector Industria, ' + occupation_construction_pct + '% en el sector de la Construcción y el ' + occupation_agriculture_pct + '% en el sector Agricultura'
                }*/

                let occupation_description = 'El ' + occupation_services_pct + '% de la població està ocupat al sector Serveis, el ' + occupation_industry_pct + '% al sector Indústria, el ' + occupation_construction_pct + '% al sector de la Construcció i el ' + occupation_agriculture_pct + '% al sector Agricultura'

                let nucleus_type = {}
                if (nucleus_population < 5000) {
                    nucleus_type = {
                        'id': 1,
                        'name_ca': 'Municipi de mida molt petita, menys de cinc mil habitants',
                        'name_en': 'Very small municipality with less than five thousand inhabitants',
                        'name_es': 'Municipio de tamaño muy pequeño, menos de cinco mil habitantes'
                    }
                } else if (nucleus_population < 20000) {
                    nucleus_type = {
                        'id': 2,
                        'name_ca': 'Municipi de mida petita, entre cinc mil i vint mil habitants',
                        'name_en': 'Small municipality, between five and twenty thousand inhabitants',
                        'name_es': 'Municipio de tamaño pequeño, entre cinco mil y veinte mil habitantes'
                    }
                } else if (nucleus_population < 50000) {
                    nucleus_type = {
                        'id': 3,
                        'name_ca': 'Municipi de mida mitjana, entre vint mil i cinquanta mil habitants',
                        'name_en': 'Medium size municipality, between twenty and fifty thousand inhabitants',
                        'name_es': 'Municipio de tamaño medio, entre veinte mil y cincuenta mil habitantes'
                    }

                } else if (nucleus_population < 100000) {
                    nucleus_type = {
                        'id': 4,
                        'name_ca': 'Municipi important, entre cinquanta mil i cent mil habitants',
                        'name_en': 'Important municipality, between fifty and one hundred thousand inhabitants',
                        'name_es': 'Municipio importante, entre cincuenta mil y cien mil habitantes'
                    }

                } else if (nucleus_population < 500000) {
                    nucleus_type = {
                        'id': 5,
                        'name_ca': 'Ciutat de mida gran, entre cent mil i cinc-cents mil habitants',
                        'name_en': 'Big city, between one hundred thousand and five hundred thousand inhabitants',
                        'name_es': 'Ciudad de gran tamaño, entre cien mil y quinientos mil habitantes'
                    }

                } else if (nucleus_population >= 500000) {
                    nucleus_type = {
                        'id': 6,
                        'name_ca': 'Gran capital, major de cinc-cents mil habitants',
                        'name_en': 'Big capital, more than five hundred thousand inhabitants',
                        'name_es': 'Gran capital, mayor de quinientos mil habitantes'
                    }
                }

                nucleus_type = nucleus_type['name_ca']

                // console.log('nucleus_type: ')
                // console.log(nucleus_type)

                commit(SET_APPRAISAL_NUCLEUS_POPULATION, nucleus_population)
                commit(SET_APPRAISAL_NUCLEUS_AREA, nucleus_area)
                commit(SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY, nucleus_population_density)
                commit(SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH, nucleus_population_growth)
                commit(SET_APPRAISAL_NUCLEUS_TYPE, nucleus_type)
                commit(SET_APPRAISAL_OCCUPATION_DESCRIPTION, occupation_description)

            })

    },
    REQUEST_MUC_INFO: ({state, commit, rootState}, data) => {

        return maps_api.request_muc_info(data)
            .then((res) => {

                console.log('request_muc_info res:')
                console.log(res)

                // parse the html response from ICC
                const div = document.createElement('div')
                div.innerHTML = res.html
                const tds = div.querySelectorAll('td')
                const trs = div.querySelectorAll('tr')

                // console.log('div: ')
                // console.log(div)

                let new_obj = {}

                for (let i = 0; i < tds.length - 1; i = i + 2) {

                    console.log('tds[i].innerText: ')
                    console.log(tds[i].innerText)

                    let key = tds[i].innerText.toLowerCase()
                    let value = tds[i + 1].innerText.toUpperCase()

                    if (tds[i].innerText.toLowerCase() === 'expedient') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'codi_clas_ajunt') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'codi_qual_ajunt') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'desc_clas_ajunt') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'desc_qual_ajunt') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'codi_clas_muc') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'codi_qual_muc') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'desc_clas_muc') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase() === 'desc_qual_muc') {
                        new_obj[key] = value
                    }
                    else if (tds[i].innerText.toLowerCase().includes('tipus')) {
                        new_obj[key] = value
                    }

                    if (!'expedient' in new_obj) {
                        if (tds[i].innerText.toLowerCase().includes('expedient')) {
                            let arr = tds[i].innerText.split('TIPUS')
                            console.log('arr: ')
                            console.log(arr)
                            if (arr.length > 0) {
                                new_obj['expedient'] = arr[0].replace('EXPEDIENT', '')
                                console.log('yeah--> new_obj[\'expedient\'] ')
                                console.log(new_obj['expedient'])
                            }

                        }
                    }

                }

                for (let i = 0; i < trs.length - 1; i = i + 2) {

                    console.log('trs[i].innerText: ')
                    console.log(trs[i].innerText)

                    if (trs[i].innerText.toLowerCase().includes('tipus')) {
                        new_obj['tipus'] = trs[i].innerText.replace('TIPUS', '')
                    }
                    /*
                    else if (trs[i].innerText.toLowerCase().includes('expedient')) {
                        console.log('it includes expedient')
                        let arr = trs[i].innerText.split('TIPUS')
                        console.log('arr: ')
                        console.log(arr)
                        if(arr.length>0){
                            new_obj['expedient'] = arr.replace('EXPEDIENT', '')
                        }

                    }
                    */

                }

                console.log('new_obj: ')
                console.log(new_obj)

                // console.log(census_obj)

                // const census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio

                commit(SET_APPRAISAL_URBAN_PLANNING_TYPE, new_obj['tipus'])
                commit(SET_APPRAISAL_URBAN_PLANNING_FILE, new_obj['expedient'])
                commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION, new_obj['codi_qual_ajunt'])
                commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION, new_obj['desc_qual_ajunt'])
                commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION, new_obj['codi_clas_ajunt'])
                commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION, new_obj['desc_clas_ajunt'])
                commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION, new_obj['codi_qual_muc'])
                commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION, new_obj['desc_qual_muc'])
                commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION, new_obj['codi_clas_muc'])
                commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION, new_obj['desc_clas_muc'])

            })

    },
    REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX: ({state, commit, rootState}, data) => {
        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise((resolve, reject) => {
            maps_api.request_map_urban_muc_land_colors_by_bbox(data)
                .then(res => {
                    // console.log('request_muc_map response in appraisal.js:')
                    // console.log(res)
                    console.log('link: ')
                    console.log(res.link)

                    commit(SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS, res.link)

                    resolve(res.link)
                }, res => {
                    console.error(res)
                    reject()
                })
        })

    },
    REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX: ({state, commit, rootState}, data) => {
        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise((resolve, reject) => {
            maps_api.request_map_urban_muc_council_qual_by_bbox(data)
                .then(res => {
                    // console.log('request_muc_map response in appraisal.js:')
                    // console.log(res)
                    console.log('link: ')
                    console.log(res.link)

                    commit(SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL, res.link)

                    resolve(res.link)
                }, res => {
                    console.error(res)
                    reject()
                })
        })

    },
    REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX: ({state, commit, rootState}, data) => {
        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise((resolve, reject) => {
            maps_api.request_map_urban_icc_topo_by_bbox(data)
                .then(res => {
                    // console.log('request_muc_map response in appraisal.js:')
                    // console.log(res)
                    console.log('link: ')
                    console.log(res.link)

                    commit(SET_APPRAISAL_MAP_URBAN_ICC_TOPO, res.link)

                    resolve(res.link)
                }, res => {
                    console.error(res)
                    reject()
                })
        })

    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL, data)
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_ICC_TOPO, data)
    },
    SET_APPRAISAL_APPRAISALDATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_APPRAISALDATE, data)
    },
    SET_APPRAISAL_VISITDATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_VISITDATE, data)
    },
    SET_APPRAISAL_TECHNICIAN_VISITING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TECHNICIAN_VISITING, data)
    },
    SET_APPRAISAL_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DATE_CREATED, data)
    },
    SET_APPRAISAL_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DATE_MODIFIED, data)
    },

    SET_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ID, data)
    },

    SET_APPRAISAL_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PATH, data)
    },
    UPDATE_APPRAISAL: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: true})
            .then((res) => {

                commit(SET_APPRAISAL_DATE_MODIFIED, res.date_modified)
                commit(SET_APPRAISAL_DIRTYNESS, false)
            })
    },
    SET_APPRAISAL_CHECKS_CADASTRAL_DATA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_CADASTRAL_DATA, data)
    },
    SET_APPRAISAL_CHECKS_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_CONSERVATION_STATUS, data)
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE, data)
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN, data)
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING, data)
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE, data)
    },
    SET_APPRAISAL_CHECKS_INTERIOR_VISIT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_INTERIOR_VISIT, data)
    },
    SET_APPRAISAL_CHECKS_OCCUPANCY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_OCCUPANCY, data)
    },
    SET_APPRAISAL_CHECKS_OTHER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_OTHER, data)
    },
    SET_APPRAISAL_CHECKS_REGISTRY_DATA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_REGISTRY_DATA, data)
    },
    SET_APPRAISAL_CHECKS_SERVITUDES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_SERVITUDES, data)
    },
    SET_APPRAISAL_CHECKS_SUBSIDY_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_SUBSIDY_STATUS, data)
    },
    SET_APPRAISAL_CHECKS_URBAN_PLANNING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CHECKS_URBAN_PLANNING, data)
    },
    SET_APPRAISAL_DOCS_APPROVED_PROJECT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_APPROVED_PROJECT, data)
    },
    SET_APPRAISAL_DOCS_CADASTRAL_DATA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_CADASTRAL_DATA, data)
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE, data)
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE, data)
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT, data)
    },
    SET_APPRAISAL_DOCS_OCCUPANCY_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_OCCUPANCY_STATUS, data)
    },
    SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT, data)
    },
    SET_APPRAISAL_DOCS_PROPERTY_SKETCH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_PROPERTY_SKETCH, data)
    },
    SET_APPRAISAL_DOCS_PROPERTY_TITLES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_PROPERTY_TITLES, data)
    },
    SET_APPRAISAL_DOCS_SITUATION_PLAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_SITUATION_PLAN, data)
    },
    SET_APPRAISAL_DOCS_SUBSIDY_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_SUBSIDY_STATUS, data)
    },
    SET_APPRAISAL_DOCS_TENYEAR_INSURANCE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_TENYEAR_INSURANCE, data)
    },
    SET_APPRAISAL_DOCS_URBAN_PLAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOCS_URBAN_PLAN, data)
    },
    SET_APPRAISAL_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DESCRIPTION, data)
    },
    SET_APPRAISAL_PURPOSE: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            commit(SET_APPRAISAL_PURPOSE, data)
            resolve()
        })
    },
    SET_APPRAISAL_PURPOSE_NOTES: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            commit(SET_APPRAISAL_PURPOSE_NOTES, data)
            resolve()
        })
    },
    SET_APPRAISAL_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TYPE, data)
    },
    SET_APPRAISAL_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_LIFT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LIFT, data)
    },
    SET_APPRAISAL_ADOPTED_AGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_AGE, data)
    },
    SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD, data)
    },
    SET_APPRAISAL_PROPERTY_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROPERTY_TYPE, data)
    },
    SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD, data)
    },
    SET_APPRAISAL_QUALITY_OF_SITUATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUALITY_OF_SITUATION, data)
    },
    SET_APPRAISAL_QUALITY_OF_CONSTRUCTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUALITY_OF_CONSTRUCTION, data)
    },
    SET_APPRAISAL_QUALITY_OF_REALESTATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUALITY_OF_REALESTATE, data)
    },
    SET_APPRAISAL_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CONSERVATION_STATUS, data)
    },
    SET_APPRAISAL_FLOOR_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FLOOR_NUMBER, data)
    },
    SET_APPRAISAL_MARKET_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MARKET_VALUE, data)
    },
    SET_APPRAISAL_MARKET_UNIT_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MARKET_UNIT_VALUE, data)
    },
    SET_APPRAISAL_BEC_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BEC_PRICE, data)
    },
    SET_APPRAISAL_ADJUSTED_BEC_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADJUSTED_BEC_PRICE, data)
    },
    SET_APPRAISAL_BC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BC, data)
    },
    SET_APPRAISAL_BC_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BC_PCT, data)
    },
    SET_APPRAISAL_GC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GC, data)
    },
    SET_APPRAISAL_GC_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GC_PCT, data)
    },
    SET_APPRAISAL_BC_AND_GC_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BC_AND_GC_PCT, data)
    },
    SET_APPRAISAL_BC_AND_GC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BC_AND_GC, data)
    },
    SET_APPRAISAL_CC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CC, data)
    },
    SET_APPRAISAL_CC_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CC_PCT, data)
    },
    SET_APPRAISAL_HTL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_HTL, data)
    },
    SET_APPRAISAL_HTL_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_HTL_PCT, data)
    },
    SET_APPRAISAL_INR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_INR, data)
    },
    SET_APPRAISAL_INR_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_INR_PCT, data)
    },
    SET_APPRAISAL_GA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GA, data)
    },
    SET_APPRAISAL_GA_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GA_PCT, data)
    },
    SET_APPRAISAL_GPD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GPD, data)
    },
    SET_APPRAISAL_GPD_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GPD_PCT, data)
    },
    SET_APPRAISAL_OCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCT, data)
    },
    SET_APPRAISAL_OCT_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCT_PCT, data)
    },
    SET_APPRAISAL_GP: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GP, data)
    },
    SET_APPRAISAL_GP_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GP_PCT, data)
    },
    SET_APPRAISAL_CC_AND_GP: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CC_AND_GP, data)
    },
    SET_APPRAISAL_F: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_F, data)
    },
    SET_APPRAISAL_CRB: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CRB, data)
    },
    SET_APPRAISAL_CCD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CCD, data)
    },
    SET_APPRAISAL_TLR_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TLR_PCT, data)
    },
    SET_APPRAISAL_PR_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PR_PCT, data)
    },
    SET_APPRAISAL_AM_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_AM_COEF, data)
    },
    SET_APPRAISAL_B1_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_B1_PCT, data)
    },
    SET_APPRAISAL_B2_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_B2_PCT, data)
    },
    SET_APPRAISAL_B_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_B_PCT, data)
    },
    SET_APPRAISAL_B_REMAINING_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_B_REMAINING_PCT, data)
    },
    SET_APPRAISAL_I_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_I_PCT, data)
    },
    SET_APPRAISAL_TENANT_AGE_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TENANT_AGE_YEARS, data)
    },
    SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS, data)
    },
    SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS, data)
    },
    SET_APPRAISAL_CESSION_BOOLEAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_BOOLEAN, data)
    },
    SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME, data)
    },
    SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME, data)
    },
    SET_APPRAISAL_CESSION_NET_YEARLY_INCOME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_NET_YEARLY_INCOME, data)
    },
    SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS, data)
    },
    SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS, data)
    },
    SET_APPRAISAL_CESSION_CONTRACT_START_DATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CESSION_CONTRACT_START_DATE, data)
    },
    SET_APPRAISAL_LANDLORD_EXPENSES_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LANDLORD_EXPENSES_PCT, data)
    },
    SET_APPRAISAL_REDUCTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REDUCTION_PCT, data)
    },
    SET_APPRAISAL_ADJUSTMENT_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADJUSTMENT_COEF, data)
    },
    SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS, data)
    },
    SET_APPRAISAL_USEFUL_LIFE_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_USEFUL_LIFE_YEARS, data)
    },
    SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS, data)
    },
    SET_APPRAISAL_MAX_LEGAL_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAX_LEGAL_PRICE, data)
    },
    SET_APPRAISAL_MAX_LEGAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAX_LEGAL_AREA, data)
    },
    SET_APPRAISAL_MATERIAL_EXECUTION_COST: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MATERIAL_EXECUTION_COST, data)
    },
    SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST, data)
    },
    SET_APPRAISAL_MEC_ADJUSTMENT_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MEC_ADJUSTMENT_COEF, data)
    },
    SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST, data)
    },
    SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT, data)
    },
    SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT, data)
    },
    SET_APPRAISAL_TOTAL_DEPRECIATION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TOTAL_DEPRECIATION_PCT, data)
    },
    SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT, data)
    },
    SET_APPRAISAL_ADOPTED_MARKET_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_MARKET_VALUE, data)
    },
    SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE, data)
    },
    SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT, data)
    },
    SET_APPRAISAL_DEPRECATED_LAND_AND_CC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DEPRECATED_LAND_AND_CC, data)
    },
    SET_APPRAISAL_FINISHED_REALESTATE_CRN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FINISHED_REALESTATE_CRN, data)
    },
    SET_APPRAISAL_CCR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CCR, data)
    },
    SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST, data)
    },
    SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN, data)
    },
    SET_APPRAISAL_K: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_K, data)
    },
    SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE, data)
    },
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE, data)
    },
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE, data)
    },
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE, data)
    },
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE, data)
    },
    SET_APPRAISAL_COMPARISON_METHOD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMPARISON_METHOD, data)
    },
    SET_APPRAISAL_ADJUSTED_MARKET_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ADJUSTED_MARKET_VALUE, data)
    },
    SET_APPRAISAL_MAX_LEGAL_METHOD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAX_LEGAL_METHOD, data)
    },
    SET_APPRAISAL_VC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_VC, data)
    },
    SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD, data)
    },
    SET_APPRAISAL_U: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_U, data)
    },
    SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT, data)
    },
    SET_APPRAISAL_RESIDUAL_DEPRECIATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_RESIDUAL_DEPRECIATION, data)
    },
    SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE, data)
    },
    SET_APPRAISAL_I: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_I, data)
    },
    SET_APPRAISAL_NP: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NP, data)
    },
    SET_APPRAISAL_COEF_1: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COEF_1, data)
    },
    SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE, data)
    },
    SET_APPRAISAL_COEF_2: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COEF_2, data)
    },
    SET_APPRAISAL_UPDATED_REVERSION_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UPDATED_REVERSION_VALUE, data)
    },
    SET_APPRAISAL_UPDATE_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UPDATE_VALUE, data)
    },
    SET_APPRAISAL_INSURANCE_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_INSURANCE_VALUE, data)
    },
    SET_APPRAISAL_VU_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_VU_COEF, data)
    },
    SET_APPRAISAL_USUFRUCT_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_USUFRUCT_VALUE, data)
    },
    SET_APPRAISAL_BARE_OWNERSHIP_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BARE_OWNERSHIP_VALUE, data)
    },
    SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE, data)
    },
    SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD, data)
    },
    SET_APPRAISAL_REALESTATE_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_ID, data)
    },
    SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN, data)
    },
    SET_APPRAISAL_PROTECTION_BOOLEAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROTECTION_BOOLEAN, data)
    },
    SET_APPRAISAL_PROTECTION_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROTECTION_TYPE, data)
    },
    SET_APPRAISAL_PROTECTION_REGIME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROTECTION_REGIME, data)
    },
    SET_APPRAISAL_PROTECTION_ZONE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROTECTION_ZONE, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_TYPE, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_FILE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_FILE, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION, data)
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION, data)
    },
    SET_APPRAISAL_LAND_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_LAND_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_LAND_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_CHECKED_AREA, data)
    },
    SET_APPRAISAL_LAND_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS, data)
    },
    SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW, data)
    },
    SET_APPRAISAL_LAND_AREA_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_AREA_NOTES, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT, data)
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY, data)
    },
    SET_APPRAISAL_PLOT_OCCUPATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PLOT_OCCUPATION, data)
    },
    SET_APPRAISAL_PLOT_FREE_AREA_USAGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PLOT_FREE_AREA_USAGE, data)
    },
    SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND, data)
    },
    SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND, data)
    },
    SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER, data)
    },
    SET_APPRAISAL_ENTRANCE_HALL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENTRANCE_HALL, data)
    },
    SET_APPRAISAL_DOORMAN_SPACE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_DOORMAN_SPACE, data)
    },
    SET_APPRAISAL_STAIRCASE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_STAIRCASE, data)
    },
    SET_APPRAISAL_SWIMMING_POOL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SWIMMING_POOL, data)
    },
    SET_APPRAISAL_GARDENED_AREAS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GARDENED_AREAS, data)
    },
    SET_APPRAISAL_SPORTS_FACILITIES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SPORTS_FACILITIES, data)
    },
    SET_APPRAISAL_COMMUNITY_ROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMUNITY_ROOM, data)
    },
    SET_APPRAISAL_STORAGE_ROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_STORAGE_ROOM, data)
    },
    SET_APPRAISAL_COMMUNITY_PARKING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMUNITY_PARKING, data)
    },
    SET_APPRAISAL_FACILITIES_OTHERS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FACILITIES_OTHERS, data)
    },
    SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND, data)
    },
    SET_APPRAISAL_FLOORS_USAGE_OVERGROUND: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_FLOORS_USAGE_OVERGROUND, data)
    },
    SET_APPRAISAL_GROUNDFLOOR_USAGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_GROUNDFLOOR_USAGE, data)
    },
    SET_APPRAISAL_COMMUNICATIONS_AIRPORT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMUNICATIONS_AIRPORT, data)
    },
    SET_APPRAISAL_COMMUNICATIONS_HARBOUR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMUNICATIONS_HARBOUR, data)
    },
    SET_APPRAISAL_COMMUNICATIONS_TRAIN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMUNICATIONS_TRAIN, data)
    },
    SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND, data)
    },
    SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN, data)
    },
    SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES, data)
    },
    SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE, data)
    },
    SET_APPRAISAL_SURROUNDING_INCOME_LEVEL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_INCOME_LEVEL, data)
    },
    SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE, data)
    },
    SET_APPRAISAL_SURROUNDING_MAIN_USES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_MAIN_USES, data)
    },
    SET_APPRAISAL_SURROUNDING_DENSITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_DENSITY, data)
    },
    SET_APPRAISAL_SURROUNDING_ACCESSIBILITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_ACCESSIBILITY, data)
    },
    SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE, data)
    },
    SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE, data)
    },
    SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED, data)
    },
    SET_APPRAISAL_SURROUNDING_AVERAGE_AGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_AVERAGE_AGE, data)
    },
    SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS, data)
    },
    SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES, data)
    },
    SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES, data)
    },
    SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING, data)
    },
    SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE, data)
    },
    SET_APPRAISAL_SURROUNDING_LEISURE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_SURROUNDING_LEISURE, data)
    },
    SET_APPRAISAL_CADASTRAL_USAGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_USAGE, data)
    },
    SET_APPRAISAL_CADASTRAL_FLOOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_FLOOR, data)
    },
    SET_APPRAISAL_CADASTRAL_DOOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_DOOR, data)
    },
    SET_APPRAISAL_CADASTRAL_BLOCK: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_BLOCK, data)
    },
    SET_APPRAISAL_CADASTRAL_STAIRCASE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_STAIRCASE, data)
    },
    SET_APPRAISAL_REGISTRY_NAME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_NAME, data)
    },
    SET_APPRAISAL_REGISTRY_SECTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_SECTION, data)
    },
    SET_APPRAISAL_REGISTRY_VOLUME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_VOLUME, data)
    },
    SET_APPRAISAL_REGISTRY_BOOK: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_BOOK, data)
    },
    SET_APPRAISAL_REGISTRY_PAGE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_PAGE, data)
    },
    SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER, data)
    },
    SET_APPRAISAL_REGISTRY_IDUFIR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_IDUFIR, data)
    },
    SET_APPRAISAL_REGISTRY_OWNER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_OWNER, data)
    },
    SET_APPRAISAL_REGISTRY_PROPERTY_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REGISTRY_PROPERTY_COEF, data)
    },
    SET_APPRAISAL_NET_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NET_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_NET_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NET_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_NET_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NET_CHECKED_AREA, data)
    },
    SET_APPRAISAL_NET_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NET_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_ENCLOSED_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENCLOSED_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_ENCLOSED_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENCLOSED_CHECKED_AREA, data)
    },
    SET_APPRAISAL_ENCLOSED_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENCLOSED_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA, data)
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA, data)
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_BUILT_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_BUILT_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_BUILT_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_CHECKED_AREA, data)
    },
    SET_APPRAISAL_BUILT_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA, data)
    },
    SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA, data)
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA, data)
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA, data)
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA, data)
    },
    SET_APPRAISAL_BATHROOMS_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BATHROOMS_NUMBER, data)
    },
    SET_APPRAISAL_BEDROOMS_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BEDROOMS_NUMBER, data)
    },
    SET_APPRAISAL_NET_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NET_SELECTED_AREA, data)
    },
    SET_APPRAISAL_ENCLOSED_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ENCLOSED_SELECTED_AREA, data)
    },
    SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA, data)
    },
    SET_APPRAISAL_BUILT_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_SELECTED_AREA, data)
    },
    SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA, data)
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA, data)
    },
    SET_APPRAISAL_LAND_SELECTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAND_SELECTED_AREA, data)
    },
    SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER, data)
    },
    SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_GAS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_GAS, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TV: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_TV, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION, data)
    },
    SET_APPRAISAL_REALESTATE_FOUNDATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_FOUNDATION, data)
    },
    SET_APPRAISAL_REALESTATE_STRUCTURE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_STRUCTURE, data)
    },
    SET_APPRAISAL_REALESTATE_ROOF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_ROOF, data)
    },
    SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES, data)
    },
    SET_APPRAISAL_REALESTATE_INSULATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INSULATION, data)
    },
    SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY, data)
    },
    SET_APPRAISAL_REALESTATE_GLAZING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_GLAZING, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM, data)
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY, data)
    },
    SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION, data)
    },
    SET_APPRAISAL_REALESTATE_MAIN_VIEWS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_MAIN_VIEWS, data)
    },
    SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY, data)
    },
    SET_APPRAISAL_REALESTATE_NOISE_FACADE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_NOISE_FACADE, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY, data)
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY, data)
    },
    SET_APPRAISAL_BEC_ADJUSTMENT_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BEC_ADJUSTMENT_COEF, data)
    },
    SET_APPRAISAL_BEC_PROPERTY_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BEC_PROPERTY_TYPE, data)
    },
    SET_APPRAISAL_BEC_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_BEC_NUMBER, data)
    },
    SET_APPRAISAL_CONSTRUCTION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CONSTRUCTION_STATUS, data)
    },
    SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT, data)
    },
    SET_APPRAISAL_CONSTRUCTION_COST_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CONSTRUCTION_COST_NOTES, data)
    },
    SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR, data)
    },
    SET_APPRAISAL_CONSTRUCTION_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_CONSTRUCTION_YEAR, data)
    },
    SET_APPRAISAL_LAST_RENOVATION_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_LAST_RENOVATION_YEAR, data)
    },
    SET_APPRAISAL_NUCLEUS_POPULATION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NUCLEUS_POPULATION, data)
    },
    SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY, data)
    },
    SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH, data)
    },
    SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT, data)
    },
    SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT, data)
    },
    SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT, data)
    },
    SET_APPRAISAL_OCCUPATION_SERVICES_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_SERVICES_PCT, data)
    },
    SET_APPRAISAL_OCCUPATION_TOTAL_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_TOTAL_PCT, data)
    },
    SET_APPRAISAL_NUCLEUS_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NUCLEUS_TYPE, data)
    },
    SET_APPRAISAL_OCCUPATION_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPATION_DESCRIPTION, data)
    },
    SET_APPRAISAL_NUCLEUS_AREA: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_NUCLEUS_AREA, data)
    },
    SET_APPRAISAL_PROPERTY_TITLE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PROPERTY_TITLE, data)
    },
    SET_APPRAISAL_USAGE_ASSIGNED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_USAGE_ASSIGNED, data)
    },
    SET_APPRAISAL_INSPECTION_REALIZED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_INSPECTION_REALIZED, data)
    },
    SET_APPRAISAL_ECONOMICAL_ACTIVITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_ECONOMICAL_ACTIVITY, data)
    },
    SET_APPRAISAL_OCCUPANCY_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_OCCUPANCY_STATUS, data)
    },
    SET_APPRAISAL_MARKETSTUDY_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MARKETSTUDY_ID, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y, data)
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM, data)
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X, data)
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y, data)
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM, data)
    },
    SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS, data)
    },
    SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS, data)
    },
    SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR, data)
    },
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY, data)
    },
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS, data)
    },
    SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES, data)
    },
    SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE, data)
    },
    SET_APPRAISAL_QUOTE_BASE_FEES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_BASE_FEES, data)
    },
    SET_APPRAISAL_QUOTE_EXCESS_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_EXCESS_PCT, data)
    },
    SET_APPRAISAL_QUOTE_BASE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_BASE_PRICE, data)
    },
    SET_APPRAISAL_QUOTE_BASE_PRICE_COEF: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_QUOTE_BASE_PRICE_COEF, data)
    },
    SET_APPRAISAL_USAGE_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_USAGE_TYPE, data)
    },
    SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER, data)
    },
}

const mutations = {

    [RESET_APPRAISAL] (state) {
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.id = null
        state.parent_path = null
        state.path = null
        state.appraisaldate = null
        state.visitdate = null
        state.technician_visiting = null
        state.description = null
        state.checks_cadastral_data = true
        state.checks_conservation_status = true
        state.checks_expropriation_procedure = false
        state.checks_expropriation_plan = false
        state.checks_expropriation_admin_ruling = false
        state.checks_expropriation_file = false
        state.checks_interior_visit = true
        state.checks_occupancy = true
        state.checks_other = null
        state.checks_registry_data = true
        state.checks_servitudes = true
        state.checks_subsidy_status = true
        state.checks_urban_planning = true
        state.docs_approved_project = false
        state.docs_cadastral_data = true
        state.docs_construction_license = false
        state.docs_construction_last_certificate = false
        state.docs_construction_contract = false
        state.docs_occupancy_status = false
        state.docs_other = null
        state.docs_photographic_report = true
        state.docs_property_sketch = true
        state.docs_property_titles = true
        state.docs_situation_plan = true
        state.docs_subsidy_status = false
        state.docs_tenyear_insurance = false
        state.docs_urban_plan = true
        state.purpose = {
            acc_eco_decree: {id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
            acc_mortgage_market_law: {id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
            bde_code: 'O',
            id: 5,
            name_ca: 'Adquisició o venda',
            name_en: 'Purchase or sale',
            name_es: 'Adquisición o venta',
            default_notes: {
                name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
                name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
                name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
            },
            default_reduction_pct: 0
        }
        state.purpose_notes = 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada'
        state.type = {
            bde_code: 'C',
            id: 1,
            name_ca: 'Taxació completa',
            name_en: 'Complete Valuation',
            name_es: 'Tasación Completa'
        }
        state.adopted_area = null
        state.lift = null
        state.adopted_age = null
        state.adopted_age_years_old = null
        state.property_type = null
        state.quality_of_neighbourhood = null
        state.quality_of_situation = null
        state.quality_of_construction = null
        state.quality_of_realestate = null
        state.conservation_status = null
        state.floor_number = null
        state.market_value = null
        state.market_unit_value = null
        state.bec_price = null
        state.adjusted_bec_price = null
        state.bc = null
        state.bc_pct = null
        state.gc = null
        state.gc_pct = null
        state.bc_and_gc_pct = null
        state.bc_and_gc = null
        state.cc = null
        state.cc_pct = null
        state.htl = null
        state.htl_pct = null
        state.inr = null
        state.inr_pct = null
        state.ga = null
        state.ga_pct = null
        state.gpd = null
        state.gpd_pct = null
        state.oct = null
        state.oct_pct = null
        state.gp = null
        state.gp_pct = null
        state.cc_and_gp = null
        state.f = null
        state.crb = null
        state.ccd = null
        state.tlr_pct = null
        state.pr_pct = null
        state.am_coef = null
        state.b1_pct = null
        state.b2_pct = null
        state.b_pct = null
        state.b_remaining_pct = null
        state.i_pct = null
        state.tenant_age_years = 35
        state.tenant_life_expectancy_years = 83
        state.tenant_remaining_life_expectancy_years = 48
        state.cession_boolean = null
        state.cession_gross_monthly_income = null
        state.cession_gross_yearly_income = null
        state.cession_net_yearly_income = null
        state.cession_contract_period_years = null
        state.cession_contract_remaining_years = null
        state.cession_contract_start_date = null
        state.landlord_expenses_pct = 70
        state.reduction_pct = null
        state.adjustment_coef = null
        state.reduction_pct = null
        state.usufructuary_age_years = null
        state.useful_life_years = null
        state.remaining_useful_life_years = null
        state.max_legal_price = null
        state.max_legal_area = null
        state.material_execution_cost = null
        state.deprecated_material_execution_cost = null
        state.mec_adjustment_coef = 1
        state.adopted_material_execution_cost = null
        state.physical_depreciation_pct = null
        state.functional_depreciation_pct = null
        state.total_depreciation_pct = null
        state.total_construction_progress_pct = 100
        state.adopted_market_value = null
        state.adopted_market_unit_value = null
        state.market_value_appraiser_adjustment_pct = null
        state.deprecated_land_and_cc = null
        state.finished_realestate_crn = null
        state.ccr = null
        state.executed_construction_cost = null
        state.under_construction_realestate_crn = null
        state.k = null
        state.repercussion_method_land_value = null
        state.cost_method_construction_crb_value = null
        state.cost_method_construction_crn_value = null
        state.cost_method_realestate_crb_value = null
        state.cost_method_realestate_crn_value = null
        state.comparison_method = null
        state.adjusted_market_value = null
        state.max_legal_method = null
        state.vc = null
        state.income_perpetuity_update_method = null
        state.u = null
        state.residual_depreciation_pct = null
        state.residual_depreciation = null
        state.realestate_residual_value = null
        state.i = null
        state.np = null
        state.coef_1 = null
        state.current_future_income_value = null
        state.coef_2 = null
        state.updated_reversion_value = null
        state.update_value = null
        state.insurance_value = null
        state.vu_coef = null
        state.usufruct_value = null
        state.bare_ownership_value = null
        state.realestate_total_adopted_value = null
        state.realestate_adopted_appraisal_method = null
        state.realestate_id = null
        state.right_of_use_boolean = null
        state.protection_boolean = null
        state.protection_type = null
        state.protection_regime = null
        state.protection_zone = null
        state.urban_planning_type = null
        state.urban_planning_file = null
        state.urban_planning_council_qualification = null
        state.urban_planning_council_qualification_description = null
        state.urban_planning_council_classification = null
        state.urban_planning_council_classification_description = null
        state.urban_planning_regional_qualification = null
        state.urban_planning_regional_qualification_description = null
        state.urban_planning_regional_classification = null
        state.urban_planning_regional_classification_description = null
        state.map_urban_muc_land_colors = null
        state.map_urban_muc_council_qual = null
        state.map_urban_icc_topo = null
        state.land_registry_area = null
        state.land_cadastral_area = null
        state.land_checked_area = null
        state.land_adopted_area = null
        state.land_infrastructure_paving_execution_pct = 100
        state.land_infrastructure_sewage_execution_pct = 100
        state.land_infrastructure_public_lighting_execution_pct = 100
        state.land_infrastructure_electricity_supply_execution_pct = 100
        state.land_infrastructure_piped_gas_execution_pct = 100
        state.land_infrastructure_telephone_service_execution_pct = 100
        state.land_infrastructure_gardened_areas_execution_pct = 100
        state.land_infrastructure_total_execution_pct = 100
        state.land_infrastructure_repercussion_cost = 150
        state.land_infrastructure_pending_investment = 0
        state.land_infrastructure_paving = true
        state.land_infrastructure_sewage = true
        state.land_infrastructure_public_lighting = true
        state.land_infrastructure_electricity_supply = true
        state.land_infrastructure_piped_gas = true
        state.land_infrastructure_telephone_service = true
        state.land_infrastructure_gardened_areas = true
        state.land_is_plot_according_to_law = true
        state.land_area_notes = null
        state.land_infrastructure_notes = null
        state.land_infrastructure_conservation_status = {
            id: 2,
            code_bde: 2,
            name_ca: 'Bona',
            name_en: 'Good',
            name_es: 'Buena',
        }
        state.land_infrastructure_water_supply_execution_pct = 100
        state.land_infrastructure_water_supply = true
        state.plot_occupation = null
        state.plot_free_area_usage = null
        state.floors_number_underground = null
        state.floors_number_overground = null
        state.parking_slots_included_in_appraisal_number = null
        state.entrance_hall = null
        state.doorman_space = null
        state.staircase = null
        state.swimming_pool = null
        state.gardened_areas = null
        state.sports_facilities = null
        state.community_room = null
        state.storage_room = null
        state.community_parking = null
        state.facilities_others = null
        state.floors_usage_underground = null
        state.floors_usage_overground = null
        state.groundfloor_usage = null
        state.communications_airport = null
        state.communications_harbour = null
        state.communications_train = null
        state.public_transport_urban_underground = null
        state.public_transport_interurban = null
        state.surrounding_facilities_notes = null
        state.surrounding_territorial_feature = null
        state.surrounding_income_level = null
        state.surrounding_homogeneity_feature = null
        state.surrounding_main_uses = null
        state.surrounding_density = null
        state.surrounding_accessibility = null
        state.surrounding_consolidation_degree = null
        state.surrounding_occupation_degree = null
        state.surrounding_evolution_speed = null
        state.surrounding_average_age = null
        state.surrounding_conservation_status = null
        state.surrounding_commercial_facilities = null
        state.surrounding_educational_facilities = null
        state.surrounding_public_parking = null
        state.surrounding_medical_assistance = null
        state.surrounding_leisure = null
        state.cadastral_usage = null
        state.cadastral_floor = null
        state.cadastral_door = null
        state.cadastral_block = null
        state.cadastral_staircase = null
        state.registry_name = null
        state.registry_section = null
        state.registry_volume = null
        state.registry_book = null
        state.registry_page = null
        state.registry_real_estate_number = null
        state.registry_idufir = null
        state.registry_owner = null
        state.registry_property_coef = null
        state.net_cadastral_area = null
        state.net_registry_area = null
        state.net_checked_area = null
        state.net_adopted_area = null
        state.enclosed_cadastral_area = null
        state.enclosed_registry_area = null
        state.enclosed_checked_area = null
        state.enclosed_adopted_area = null
        state.covered_terraces_total_cadastral_area = null
        state.covered_terraces_total_registry_area = null
        state.covered_terraces_total_checked_area = null
        state.covered_terraces_total_adopted_area = null
        state.uncovered_terraces_total_cadastral_area = null
        state.uncovered_terraces_total_registry_area = null
        state.uncovered_terraces_total_checked_area = null
        state.uncovered_terraces_total_adopted_area = null
        state.built_cadastral_area = null
        state.built_registry_area = null
        state.built_checked_area = null
        state.built_adopted_area = null
        state.common_elements_cadastral_area = null
        state.common_elements_registry_area = null
        state.common_elements_checked_area = null
        state.common_elements_adopted_area = null
        state.built_plus_common_elements_cadastral_area = null
        state.built_plus_common_elements_registry_area = null
        state.built_plus_common_elements_checked_area = null
        state.built_plus_common_elements_adopted_area = null
        state.bathrooms_number = null
        state.bedrooms_number = null
        state.net_selected_area = null
        state.enclosed_selected_area = null
        state.covered_outdoors_selected_area = null
        state.built_selected_areacommon_elements_selected_area = null
        state.built_plus_common_elements_selected_area = null
        state.net_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.enclosed_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.covered_outdoors_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.built_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.common_elements_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.built_plus_common_elements_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.land_selected_area = {
            id: 1,
            name_ca: 'Auto',
            name_en: 'Auto',
            name_es: 'Auto'
        }
        state.realestate_rooms_to_exterior_number = null
        state.realestate_day_night_zoning = null
        state.realestate_systems_door_opener = null
        state.realestate_systems_fitted_cupboards = null
        state.realestate_systems_gas = null
        state.realestate_systems_sanitary_fittings = null
        state.realestate_systems_taps = null
        state.realestate_systems_hot_water = null
        state.realestate_systems_heating = null
        state.realestate_systems_air_conditioning = null
        state.realestate_systems_tv = null
        state.realestate_systems_telephone = null
        state.realestate_systems_fire_prevention = null
        state.realestate_systems_intrusion_prevention = null
        state.realestate_foundation = null
        state.realestate_structure = null
        state.realestate_roof = null
        state.realestate_external_enclosures = null
        state.realestate_insulation = null
        state.realestate_external_carpentry = null
        state.realestate_glazing = null
        state.realestate_interior_paving_living = null
        state.realestate_interior_paving_corridor = null
        state.realestate_interior_paving_bedroom = null
        state.realestate_interior_paving_kitchen = null
        state.realestate_interior_paving_bathroom = null
        state.realestate_interior_paving_quality = null
        state.realestate_interior_walls_living = null
        state.realestate_interior_walls_corridor = null
        state.realestate_interior_walls_bedroom = null
        state.realestate_interior_walls_kitchen = null
        state.realestate_interior_walls_bathroom = null
        state.realestate_interior_walls_quality = null
        state.realestate_interior_ceilings_living = null
        state.realestate_interior_ceilings_corridor = null
        state.realestate_interior_ceilings_bedroom = null
        state.realestate_interior_ceilings_kitchen = null
        state.realestate_interior_ceilings_bathroom = null
        state.realestate_interior_ceilings_quality = null
        state.realestate_interior_carpentry_living = null
        state.realestate_interior_carpentry_corridor = null
        state.realestate_interior_carpentry_bedroom = null
        state.realestate_interior_carpentry_kitchen = null
        state.realestate_interior_carpentry_bathroom = null
        state.realestate_interior_carpentry_quality = null
        state.realestate_main_orientation = null
        state.realestate_main_views = null
        state.realestate_windows_size_and_quantity = null
        state.realestate_noise_facade = null
        state.realestate_systems_sanitary_fittings_quality = null
        state.realestate_systems_taps_quality = null
        state.bec_adjustment_coef = 1
        state.bec_property_type = null
        state.bec_number = null
        state.construction_status = {
            id: 1,
            name_ca: 'Acabat',
            name_es: 'Terminado',
            name_en: 'Finished',
            code_bde: 'U00'
        }
        state.expenses_and_industrial_benefit_bec_pct = 20
        state.construction_cost_notes = null
        state.cadastral_construction_year = null
        state.construction_year = null
        state.last_renovation_year = null
        state.nucleus_population = null
        state.nucleus_population_density = null
        state.nucleus_population_growth = null
        state.occupation_agriculture_pct = null
        state.occupation_industry_pct = null
        state.occupation_construction_pct = null
        state.occupation_services_pct = null
        state.occupation_total_pct = null
        state.nucleus_type = null
        state.occupation_description = null
        state.nucleus_area = null
        state.property_title = null
        state.usage_assigned = null
        state.inspection_realized = null
        state.economical_activity = null
        state.occupancy_status = null
        state.marketstudy_id = null
        state.notes = {
            note_001: {
                name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
                name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
                name_en: ''
            },
            note_002: {
                name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
                name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
                name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
            },
            note_003: {
                name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
                name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
            },
            note_004: {
                name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
                name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
                name_en: 'Both BARNA-TASA, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
            },
            note_005: {
                name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
                name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
                name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
            },
            note_006: {
                name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
                name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
                name_en: 'The valuation has been made considering the property is free of charges and liens'
            }
        }
        state.map_urban_muc_land_colors_offset_x = 0
        state.map_urban_muc_land_colors_offset_y = 0
        state.map_urban_muc_land_colors_zoom = 1
        state.map_urban_muc_council_qual_offset_x = 0
        state.map_urban_muc_council_qual_offset_y = 0
        state.map_urban_muc_council_qual_zoom = 1
        state.map_urban_icc_topo_offset_x = 0
        state.map_urban_icc_topo_offset_y = 0
        state.map_urban_icc_topo_zoom = 1

        state.quote_travel_one_way_hours = 0
        state.quote_travel_both_ways_hours = 0
        state.quote_travel_fees_per_hour = 20
        state.quote_car_expenses_one_way = 0
        state.quote_car_expenses_both_ways = 0
        state.quote_total_travel_fees = 0
        state.quote_area_average_unit_price = null
        state.quote_base_fees = null
        state.quote_excess_pct = null
        state.quote_base_price = null
        state.quote_base_price_coef = 1
        state.usage_type = null
        state.parking_spots_included_number = null

    },
    [SET_APPRAISAL] (state, data) {
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.id = check_undefined(data.id)
        state.parent_path = check_undefined(data.parent_path)
        state.path = check_undefined(data.path)
        state.appraisaldate = check_undefined(data.appraisaldate)
        state.visitdate = check_undefined(data.visitdate)
        state.technician_visiting = check_undefined(data.technician_visiting)
        state.description = check_undefined(data.description)
        state.purpose = check_undefined(data.purpose)
        state.purpose_notes = check_undefined(data.purpose_notes)
        state.type = check_undefined(data.type)
        state.checks_cadastral_data = check_undefined(data.checks_cadastral_data)
        state.checks_conservation_status = check_undefined(data.checks_conservation_status)
        state.checks_expropriation_procedure = check_undefined(data.checks_expropriation_procedure)
        state.checks_expropriation_plan = check_undefined(data.checks_expropriation_plan)
        state.checks_expropriation_admin_ruling = check_undefined(data.checks_expropriation_admin_ruling)
        state.checks_expropriation_file = check_undefined(data.checks_expropriation_file)
        state.checks_interior_visit = check_undefined(data.checks_interior_visit)
        state.checks_occupancy = check_undefined(data.checks_occupancy)
        state.checks_other = check_undefined(data.checks_other)
        state.checks_registry_data = check_undefined(data.checks_registry_data)
        state.checks_servitudes = check_undefined(data.checks_servitudes)
        state.checks_subsidy_status = check_undefined(data.checks_subsidy_status)
        state.checks_urban_planning = check_undefined(data.checks_urban_planning)
        state.docs_approved_project = check_undefined(data.docs_approved_project)
        state.docs_cadastral_data = check_undefined(data.docs_cadastral_data)
        state.docs_construction_license = check_undefined(data.docs_construction_license)
        state.docs_construction_last_certificate = check_undefined(data.docs_construction_last_certificate)
        state.docs_construction_contract = check_undefined(data.docs_construction_contract)
        state.docs_occupancy_status = check_undefined(data.docs_occupancy_status)
        state.docs_other = check_undefined(data.docs_other)
        state.docs_photographic_report = check_undefined(data.docs_photographic_report)
        state.docs_property_sketch = check_undefined(data.docs_property_sketch)
        state.docs_property_titles = check_undefined(data.docs_property_titles)
        state.docs_situation_plan = check_undefined(data.docs_situation_plan)
        state.docs_subsidy_status = check_undefined(data.docs_subsidy_status)
        state.docs_tenyear_insurance = check_undefined(data.docs_tenyear_insurance)
        state.docs_urban_plan = check_undefined(data.docs_urban_plan)
        state.adopted_area = check_undefined(data.adopted_area)
        state.lift = check_undefined(data.lift)
        state.adopted_age = check_undefined(data.adopted_age)
        state.adopted_age_years_old = check_undefined(data.adopted_age_years_old)
        state.property_type = check_undefined(data.property_type)
        state.quality_of_neighbourhood = check_undefined(data.quality_of_neighbourhood)
        state.quality_of_situation = check_undefined(data.quality_of_situation)
        state.quality_of_construction = check_undefined(data.quality_of_construction)
        state.quality_of_realestate = check_undefined(data.quality_of_realestate)
        state.conservation_status = check_undefined(data.conservation_status)
        state.floor_number = check_undefined(data.floor_number)
        state.market_value = check_undefined(data.market_value)
        state.market_unit_value = check_undefined(data.market_unit_value)
        state.bec_price = check_undefined(data.bec_price)
        state.adjusted_bec_price = check_undefined(data.adjusted_bec_price)
        state.bc = check_undefined(data.bc)
        state.bc_pct = check_undefined(data.bc_pct)
        state.gc = check_undefined(data.gc)
        state.gc_pct = check_undefined(data.gc_pct)
        state.bc_and_gc_pct = check_undefined(data.bc_and_gc_pct)
        state.bc_and_gc = check_undefined(data.bc_and_gc)
        state.cc = check_undefined(data.cc)
        state.cc_pct = check_undefined(data.cc_pct)
        state.htl = check_undefined(data.htl)
        state.htl_pct = check_undefined(data.htl_pct)
        state.inr = check_undefined(data.inr)
        state.inr_pct = check_undefined(data.inr_pct)
        state.ga = check_undefined(data.ga)
        state.ga_pct = check_undefined(data.ga_pct)
        state.gpd = check_undefined(data.gpd)
        state.gpd_pct = check_undefined(data.gpd_pct)
        state.oct = check_undefined(data.oct)
        state.oct_pct = check_undefined(data.oct_pct)
        state.gp = check_undefined(data.gp)
        state.gp_pct = check_undefined(data.gp_pct)
        state.cc_and_gp = check_undefined(data.cc_and_gp)
        state.f = check_undefined(data.f)
        state.crb = check_undefined(data.crb)
        state.ccd = check_undefined(data.ccd)
        state.tlr_pct = check_undefined(data.tlr_pct)
        state.pr_pct = check_undefined(data.pr_pct)
        state.am_coef = check_undefined(data.am_coef)
        state.b1_pct = check_undefined(data.b1_pct)
        state.b2_pct = check_undefined(data.b2_pct)
        state.b_pct = check_undefined(data.b_pct)
        state.b_remaining_pct = check_undefined(data.b_remaining_pct)
        state.i_pct = check_undefined(data.i_pct)
        state.tenant_age_years = check_undefined(data.tenant_age_years)
        state.tenant_life_expectancy_years = check_undefined(data.tenant_life_expectancy_years)
        state.tenant_remaining_life_expectancy_years = check_undefined(data.tenant_remaining_life_expectancy_years)
        state.cession_boolean = check_undefined(data.cession_boolean)
        state.cession_gross_monthly_income = check_undefined(data.cession_gross_monthly_income)
        state.cession_gross_yearly_income = check_undefined(data.cession_gross_yearly_income)
        state.cession_net_yearly_income = check_undefined(data.cession_net_yearly_income)
        state.cession_contract_period_years = check_undefined(data.cession_contract_period_years)
        state.cession_contract_remaining_years = check_undefined(data.cession_contract_remaining_years)
        state.cession_contract_start_date = check_undefined(data.cession_contract_start_date)
        state.landlord_expenses_pct = check_undefined(data.landlord_expenses_pct)
        state.reduction_pct = check_undefined(data.reduction_pct)
        state.adjustment_coef = check_undefined(data.adjustment_coef)
        state.usufructuary_age_years = check_undefined(data.usufructuary_age_years)
        state.useful_life_years = check_undefined(data.useful_life_years)
        state.remaining_useful_life_years = check_undefined(data.remaining_useful_life_years)
        state.max_legal_price = check_undefined(data.max_legal_price)
        state.max_legal_area = check_undefined(data.max_legal_area)
        state.material_execution_cost = check_undefined(data.material_execution_cost)
        state.deprecated_material_execution_cost = check_undefined(data.deprecated_material_execution_cost)
        state.mec_adjustment_coef = check_undefined(data.mec_adjustment_coef)
        state.adopted_material_execution_cost = check_undefined(data.adopted_material_execution_cost)
        state.physical_depreciation_pct = check_undefined(data.physical_depreciation_pct)
        state.functional_depreciation_pct = check_undefined(data.functional_depreciation_pct)
        state.total_depreciation_pct = check_undefined(data.total_depreciation_pct)
        state.total_construction_progress_pct = check_undefined(data.total_construction_progress_pct)
        state.adopted_market_value = check_undefined(data.adopted_market_value)
        state.adopted_market_unit_value = check_undefined(data.adopted_market_unit_value)
        state.market_value_appraiser_adjustment_pct = check_undefined(data.market_value_appraiser_adjustment_pct)
        state.deprecated_land_and_cc = check_undefined(data.deprecated_land_and_cc)
        state.finished_realestate_crn = check_undefined(data.finished_realestate_crn)
        state.ccr = check_undefined(data.ccr)
        state.executed_construction_cost = check_undefined(data.executed_construction_cost)
        state.under_construction_realestate_crn = check_undefined(data.under_construction_realestate_crn)
        state.k = check_undefined(data.k)
        state.repercussion_method_land_value = check_undefined(data.repercussion_method_land_value)
        state.cost_method_construction_crb_value = check_undefined(data.cost_method_construction_crb_value)
        state.cost_method_construction_crn_value = check_undefined(data.cost_method_construction_crn_value)
        state.cost_method_realestate_crb_value = check_undefined(data.cost_method_realestate_crb_value)
        state.cost_method_realestate_crn_value = check_undefined(data.cost_method_realestate_crn_value)
        state.comparison_method = check_undefined(data.comparison_method)
        state.adjusted_market_value = check_undefined(data.adjusted_market_value)
        state.max_legal_method = check_undefined(data.max_legal_method)
        state.vc = check_undefined(data.vc)
        state.income_perpetuity_update_method = check_undefined(data.income_perpetuity_update_method)
        state.u = check_undefined(data.u)
        state.residual_depreciation_pct = check_undefined(data.residual_depreciation_pct)
        state.residual_depreciation = check_undefined(data.residual_depreciation)
        state.realestate_residual_value = check_undefined(data.realestate_residual_value)
        state.i = check_undefined(data.i)
        state.np = check_undefined(data.np)
        state.coef_1 = check_undefined(data.coef_1)
        state.current_future_income_value = check_undefined(data.current_future_income_value)
        state.coef_2 = check_undefined(data.coef_2)
        state.updated_reversion_value = check_undefined(data.updated_reversion_value)
        state.update_value = check_undefined(data.update_value)
        state.insurance_value = check_undefined(data.insurance_value)
        state.vu_coef = check_undefined(data.vu_coef)
        state.usufruct_value = check_undefined(data.usufruct_value)
        state.bare_ownership_value = check_undefined(data.bare_ownership_value)
        state.realestate_total_adopted_value = check_undefined(data.realestate_total_adopted_value)
        state.realestate_adopted_appraisal_method = check_undefined(data.realestate_adopted_appraisal_method)
        state.realestate_id = check_undefined(data.realestate_id)
        state.right_of_use_boolean = check_undefined(data.right_of_use_boolean)
        state.protection_boolean = check_undefined(data.protection_boolean)
        state.protection_type = check_undefined(data.protection_type)
        state.protection_regime = check_undefined(data.protection_regime)
        state.protection_zone = check_undefined(data.protection_zone)
        state.urban_planning_type = check_undefined(data.urban_planning_type)
        state.urban_planning_file = check_undefined(data.urban_planning_file)
        state.urban_planning_council_qualification = check_undefined(data.urban_planning_council_qualification)
        state.urban_planning_council_qualification_description = check_undefined(data.urban_planning_council_qualification_description)
        state.urban_planning_council_classification = check_undefined(data.urban_planning_council_classification)
        state.urban_planning_council_classification_description = check_undefined(data.urban_planning_council_classification_description)
        state.urban_planning_regional_qualification = check_undefined(data.urban_planning_regional_qualification)
        state.urban_planning_regional_qualification_description = check_undefined(data.urban_planning_regional_qualification_description)
        state.urban_planning_regional_classification = check_undefined(data.urban_planning_regional_classification)
        state.urban_planning_regional_classification_description = check_undefined(data.urban_planning_regional_classification_description)
        state.map_urban_muc_land_colors = check_undefined(data.map_urban_muc_land_colors)
        state.map_urban_muc_council_qual = check_undefined(data.map_urban_muc_council_qual)
        state.map_urban_icc_topo = check_undefined(data.map_urban_icc_topo)
        state.land_registry_area = check_undefined(data.land_registry_area)
        state.land_cadastral_area = check_undefined(data.land_cadastral_area)
        state.land_checked_area = check_undefined(data.land_checked_area)
        state.land_adopted_area = check_undefined(data.land_adopted_area)
        state.land_infrastructure_paving_execution_pct = check_undefined(data.land_infrastructure_paving_execution_pct)
        state.land_infrastructure_sewage_execution_pct = check_undefined(data.land_infrastructure_sewage_execution_pct)
        state.land_infrastructure_public_lighting_execution_pct = check_undefined(data.land_infrastructure_public_lighting_execution_pct)
        state.land_infrastructure_electricity_supply_execution_pct = check_undefined(data.land_infrastructure_electricity_supply_execution_pct)
        state.land_infrastructure_piped_gas_execution_pct = check_undefined(data.land_infrastructure_piped_gas_execution_pct)
        state.land_infrastructure_telephone_service_execution_pct = check_undefined(data.land_infrastructure_telephone_service_execution_pct)
        state.land_infrastructure_gardened_areas_execution_pct = check_undefined(data.land_infrastructure_gardened_areas_execution_pct)
        state.land_infrastructure_total_execution_pct = check_undefined(data.land_infrastructure_total_execution_pct)
        state.land_infrastructure_repercussion_cost = check_undefined(data.land_infrastructure_repercussion_cost)
        state.land_infrastructure_pending_investment = check_undefined(data.land_infrastructure_pending_investment)
        state.land_infrastructure_paving = check_undefined(data.land_infrastructure_paving)
        state.land_infrastructure_sewage = check_undefined(data.land_infrastructure_sewage)
        state.land_infrastructure_public_lighting = check_undefined(data.land_infrastructure_public_lighting)
        state.land_infrastructure_electricity_supply = check_undefined(data.land_infrastructure_electricity_supply)
        state.land_infrastructure_piped_gas = check_undefined(data.land_infrastructure_piped_gas)
        state.land_infrastructure_telephone_service = check_undefined(data.land_infrastructure_telephone_service)
        state.land_infrastructure_gardened_areas = check_undefined(data.land_infrastructure_gardened_areas)
        state.land_is_plot_according_to_law = check_undefined(data.land_is_plot_according_to_law)
        state.land_area_notes = check_undefined(data.land_area_notes)
        state.land_infrastructure_notes = check_undefined(data.land_infrastructure_notes)
        state.land_infrastructure_conservation_status = check_undefined(data.land_infrastructure_conservation_status)
        state.land_infrastructure_water_supply_execution_pct = check_undefined(data.land_infrastructure_water_supply_execution_pct)
        state.land_infrastructure_water_supply = check_undefined(data.land_infrastructure_water_supply)
        state.plot_occupation = check_undefined(data.plot_occupation)
        state.plot_free_area_usage = check_undefined(data.plot_free_area_usage)
        state.floors_number_underground = check_undefined(data.floors_number_underground)
        state.floors_number_overground = check_undefined(data.floors_number_overground)
        state.parking_slots_included_in_appraisal_number = check_undefined(data.parking_slots_included_in_appraisal_number)
        state.entrance_hall = check_undefined(data.entrance_hall)
        state.doorman_space = check_undefined(data.doorman_space)
        state.staircase = check_undefined(data.staircase)
        state.swimming_pool = check_undefined(data.swimming_pool)
        state.gardened_areas = check_undefined(data.gardened_areas)
        state.sports_facilities = check_undefined(data.sports_facilities)
        state.community_room = check_undefined(data.community_room)
        state.storage_room = check_undefined(data.storage_room)
        state.community_parking = check_undefined(data.community_parking)
        state.facilities_others = check_undefined(data.facilities_others)
        state.floors_usage_underground = check_undefined(data.floors_usage_underground)
        state.floors_usage_overground = check_undefined(data.floors_usage_overground)
        state.groundfloor_usage = check_undefined(data.groundfloor_usage)
        state.communications_airport = check_undefined(data.communications_airport)
        state.communications_harbour = check_undefined(data.communications_harbour)
        state.communications_train = check_undefined(data.communications_train)
        state.public_transport_urban_underground = check_undefined(data.public_transport_urban_underground)
        state.public_transport_interurban = check_undefined(data.public_transport_interurban)
        state.surrounding_facilities_notes = check_undefined(data.surrounding_facilities_notes)
        state.surrounding_territorial_feature = check_undefined(data.surrounding_territorial_feature)
        state.surrounding_income_level = check_undefined(data.surrounding_income_level)
        state.surrounding_homogeneity_feature = check_undefined(data.surrounding_homogeneity_feature)
        state.surrounding_main_uses = check_undefined(data.surrounding_main_uses)
        state.surrounding_density = check_undefined(data.surrounding_density)
        state.surrounding_accessibility = check_undefined(data.surrounding_accessibility)
        state.surrounding_consolidation_degree = check_undefined(data.surrounding_consolidation_degree)
        state.surrounding_occupation_degree = check_undefined(data.surrounding_occupation_degree)
        state.surrounding_evolution_speed = check_undefined(data.surrounding_evolution_speed)
        state.surrounding_average_age = check_undefined(data.surrounding_average_age)
        state.surrounding_conservation_status = check_undefined(data.surrounding_conservation_status)
        state.surrounding_commercial_facilities = check_undefined(data.surrounding_commercial_facilities)
        state.surrounding_educational_facilities = check_undefined(data.surrounding_educational_facilities)
        state.surrounding_public_parking = check_undefined(data.surrounding_public_parking)
        state.surrounding_medical_assistance = check_undefined(data.surrounding_medical_assistance)
        state.surrounding_leisure = check_undefined(data.surrounding_leisure)
        state.cadastral_usage = check_undefined(data.cadastral_usage)
        state.cadastral_floor = check_undefined(data.cadastral_floor)
        state.cadastral_door = check_undefined(data.cadastral_door)
        state.cadastral_block = check_undefined(data.cadastral_block)
        state.cadastral_staircase = check_undefined(data.cadastral_staircase)
        state.registry_name = check_undefined(data.registry_name)
        state.registry_section = check_undefined(data.registry_section)
        state.registry_volume = check_undefined(data.registry_volume)
        state.registry_book = check_undefined(data.registry_book)
        state.registry_page = check_undefined(data.registry_page)
        state.registry_real_estate_number = check_undefined(data.registry_real_estate_number)
        state.registry_idufir = check_undefined(data.registry_idufir)
        state.registry_owner = check_undefined(data.registry_owner)
        state.registry_property_coef = check_undefined(data.registry_property_coef)
        state.net_cadastral_area = check_undefined(data.net_cadastral_area)
        state.net_registry_area = check_undefined(data.net_registry_area)
        state.net_checked_area = check_undefined(data.net_checked_area)
        state.net_adopted_area = check_undefined(data.net_adopted_area)
        state.enclosed_cadastral_area = check_undefined(data.enclosed_cadastral_area)
        state.enclosed_registry_area = check_undefined(data.enclosed_registry_area)
        state.enclosed_checked_area = check_undefined(data.enclosed_checked_area)
        state.enclosed_adopted_area = check_undefined(data.enclosed_adopted_area)
        state.covered_terraces_total_cadastral_area = check_undefined(data.covered_terraces_total_cadastral_area)
        state.covered_terraces_total_registry_area = check_undefined(data.covered_terraces_total_registry_area)
        state.covered_terraces_total_checked_area = check_undefined(data.covered_terraces_total_checked_area)
        state.covered_terraces_total_adopted_area = check_undefined(data.covered_terraces_total_adopted_area)
        state.uncovered_terraces_total_cadastral_area = check_undefined(data.uncovered_terraces_total_cadastral_area)
        state.uncovered_terraces_total_registry_area = check_undefined(data.uncovered_terraces_total_registry_area)
        state.uncovered_terraces_total_checked_area = check_undefined(data.uncovered_terraces_total_checked_area)
        state.uncovered_terraces_total_adopted_area = check_undefined(data.uncovered_terraces_total_adopted_area)
        state.built_cadastral_area = check_undefined(data.built_cadastral_area)
        state.built_registry_area = check_undefined(data.built_registry_area)
        state.built_checked_area = check_undefined(data.built_checked_area)
        state.built_adopted_area = check_undefined(data.built_adopted_area)
        state.common_elements_cadastral_area = check_undefined(data.common_elements_cadastral_area)
        state.common_elements_registry_area = check_undefined(data.common_elements_registry_area)
        state.common_elements_checked_area = check_undefined(data.common_elements_checked_area)
        state.common_elements_adopted_area = check_undefined(data.common_elements_adopted_area)
        state.built_plus_common_elements_cadastral_area = check_undefined(data.built_plus_common_elements_cadastral_area)
        state.built_plus_common_elements_registry_area = check_undefined(data.built_plus_common_elements_registry_area)
        state.built_plus_common_elements_checked_area = check_undefined(data.built_plus_common_elements_checked_area)
        state.built_plus_common_elements_adopted_area = check_undefined(data.built_plus_common_elements_adopted_area)
        state.bathrooms_number = check_undefined(data.bathrooms_number)
        state.bedrooms_number = check_undefined(data.bedrooms_number)
        state.net_selected_area = check_undefined(data.net_selected_area)
        state.enclosed_selected_area = check_undefined(data.enclosed_selected_area)
        state.covered_outdoors_selected_area = check_undefined(data.covered_outdoors_selected_area)
        state.built_selected_areacommon_elements_selected_area = check_undefined(data.built_selected_areacommon_elements_selected_area)
        state.built_plus_common_elements_selected_area = check_undefined(data.built_plus_common_elements_selected_area)
        state.land_selected_area = check_undefined(data.land_selected_area)
        state.net_selected_area = check_undefined(data.net_selected_area)
        state.enclosed_selected_area = check_undefined(data.enclosed_selected_area)
        state.covered_outdoors_selected_area = check_undefined(data.covered_outdoors_selected_area)
        state.built_selected_area = check_undefined(data.built_selected_area)
        state.common_elements_selected_area = check_undefined(data.common_elements_selected_area)
        state.built_plus_common_elements_selected_area = check_undefined(data.built_plus_common_elements_selected_area)
        state.land_selected_area = check_undefined(data.land_selected_area)
        state.realestate_rooms_to_exterior_number = check_undefined(data.realestate_rooms_to_exterior_number)
        state.realestate_day_night_zoning = check_undefined(data.realestate_day_night_zoning)
        state.realestate_systems_door_opener = check_undefined(data.realestate_systems_door_opener)
        state.realestate_systems_fitted_cupboards = check_undefined(data.realestate_systems_fitted_cupboards)
        state.realestate_systems_gas = check_undefined(data.realestate_systems_gas)
        state.realestate_systems_sanitary_fittings = check_undefined(data.realestate_systems_sanitary_fittings)
        state.realestate_systems_taps = check_undefined(data.realestate_systems_taps)
        state.realestate_systems_hot_water = check_undefined(data.realestate_systems_hot_water)
        state.realestate_systems_heating = check_undefined(data.realestate_systems_heating)
        state.realestate_systems_air_conditioning = check_undefined(data.realestate_systems_air_conditioning)
        state.realestate_systems_tv = check_undefined(data.realestate_systems_tv)
        state.realestate_systems_telephone = check_undefined(data.realestate_systems_telephone)
        state.realestate_systems_fire_prevention = check_undefined(data.realestate_systems_fire_prevention)
        state.realestate_systems_intrusion_prevention = check_undefined(data.realestate_systems_intrusion_prevention)
        state.realestate_foundation = check_undefined(data.realestate_foundation)
        state.realestate_structure = check_undefined(data.realestate_structure)
        state.realestate_roof = check_undefined(data.realestate_roof)
        state.realestate_external_enclosures = check_undefined(data.realestate_external_enclosures)
        state.realestate_insulation = check_undefined(data.realestate_insulation)
        state.realestate_external_carpentry = check_undefined(data.realestate_external_carpentry)
        state.realestate_glazing = check_undefined(data.realestate_glazing)
        state.realestate_interior_paving_living = check_undefined(data.realestate_interior_paving_living)
        state.realestate_interior_paving_corridor = check_undefined(data.realestate_interior_paving_corridor)
        state.realestate_interior_paving_bedroom = check_undefined(data.realestate_interior_paving_bedroom)
        state.realestate_interior_paving_kitchen = check_undefined(data.realestate_interior_paving_kitchen)
        state.realestate_interior_paving_bathroom = check_undefined(data.realestate_interior_paving_bathroom)
        state.realestate_interior_paving_quality = check_undefined(data.realestate_interior_paving_quality)
        state.realestate_interior_walls_living = check_undefined(data.realestate_interior_walls_living)
        state.realestate_interior_walls_corridor = check_undefined(data.realestate_interior_walls_corridor)
        state.realestate_interior_walls_bedroom = check_undefined(data.realestate_interior_walls_bedroom)
        state.realestate_interior_walls_kitchen = check_undefined(data.realestate_interior_walls_kitchen)
        state.realestate_interior_walls_bathroom = check_undefined(data.realestate_interior_walls_bathroom)
        state.realestate_interior_walls_quality = check_undefined(data.realestate_interior_walls_quality)
        state.realestate_interior_ceilings_living = check_undefined(data.realestate_interior_ceilings_living)
        state.realestate_interior_ceilings_corridor = check_undefined(data.realestate_interior_ceilings_corridor)
        state.realestate_interior_ceilings_bedroom = check_undefined(data.realestate_interior_ceilings_bedroom)
        state.realestate_interior_ceilings_kitchen = check_undefined(data.realestate_interior_ceilings_kitchen)
        state.realestate_interior_ceilings_bathroom = check_undefined(data.realestate_interior_ceilings_bathroom)
        state.realestate_interior_ceilings_quality = check_undefined(data.realestate_interior_ceilings_quality)
        state.realestate_interior_carpentry_living = check_undefined(data.realestate_interior_carpentry_living)
        state.realestate_interior_carpentry_corridor = check_undefined(data.realestate_interior_carpentry_corridor)
        state.realestate_interior_carpentry_bedroom = check_undefined(data.realestate_interior_carpentry_bedroom)
        state.realestate_interior_carpentry_kitchen = check_undefined(data.realestate_interior_carpentry_kitchen)
        state.realestate_interior_carpentry_bathroom = check_undefined(data.realestate_interior_carpentry_bathroom)
        state.realestate_interior_carpentry_quality = check_undefined(data.realestate_interior_carpentry_quality)
        state.realestate_main_orientation = check_undefined(data.realestate_main_orientation)
        state.realestate_main_views = check_undefined(data.realestate_main_views)
        state.realestate_windows_size_and_quantity = check_undefined(data.realestate_windows_size_and_quantity)
        state.realestate_noise_facade = check_undefined(data.realestate_noise_facade)
        state.realestate_systems_sanitary_fittings_quality = check_undefined(data.realestate_systems_sanitary_fittings_quality)
        state.realestate_systems_taps_quality = check_undefined(data.realestate_systems_taps_quality)
        state.bec_adjustment_coef = check_undefined(data.bec_adjustment_coef)
        state.bec_property_type = check_undefined(data.bec_property_type)
        state.bec_number = check_undefined(data.bec_number)
        state.construction_status = check_undefined(data.construction_status)
        state.expenses_and_industrial_benefit_bec_pct = check_undefined(data.expenses_and_industrial_benefit_bec_pct)
        state.construction_cost_notes = check_undefined(data.construction_cost_notes)
        state.cadastral_construction_year = check_undefined(data.cadastral_construction_year)
        state.construction_year = check_undefined(data.construction_year)
        state.last_renovation_year = check_undefined(data.last_renovation_year)
        state.nucleus_population = check_undefined(data.nucleus_population)
        state.nucleus_population_density = check_undefined(data.nucleus_population_density)
        state.nucleus_population_growth = check_undefined(data.nucleus_population_growth)
        state.occupation_agriculture_pct = check_undefined(data.occupation_agriculture_pct)
        state.occupation_industry_pct = check_undefined(data.occupation_industry_pct)
        state.occupation_construction_pct = check_undefined(data.occupation_construction_pct)
        state.occupation_services_pct = check_undefined(data.occupation_services_pct)
        state.occupation_total_pct = check_undefined(data.occupation_total_pct)
        state.nucleus_type = check_undefined(data.nucleus_type)
        state.occupation_description = check_undefined(data.occupation_description)
        state.nucleus_area = check_undefined(data.nucleus_area)
        state.property_title = check_undefined(data.property_title)
        state.usage_assigned = check_undefined(data.usage_assigned)
        state.inspection_realized = check_undefined(data.inspection_realized)
        state.economical_activity = check_undefined(data.economical_activity)
        state.occupancy_status = check_undefined(data.occupancy_status)
        state.marketstudy_id = check_undefined(data.marketstudy_id)
        state.map_urban_muc_land_colors_offset_x = check_undefined(data.map_urban_muc_land_colors_offset_x)
        state.map_urban_muc_land_colors_offset_y = check_undefined(data.map_urban_muc_land_colors_offset_y)
        state.map_urban_muc_land_colors_zoom = check_undefined(data.map_urban_muc_land_colors_zoom)
        state.map_urban_muc_council_qual_offset_x = check_undefined(data.map_urban_muc_council_qual_offset_x)
        state.map_urban_muc_council_qual_offset_y = check_undefined(data.map_urban_muc_council_qual_offset_y)
        state.map_urban_muc_council_qual_zoom = check_undefined(data.map_urban_muc_council_qual_zoom)
        state.map_urban_icc_topo_offset_x = check_undefined(data.map_urban_icc_topo_offset_x)
        state.map_urban_icc_topo_offset_y = check_undefined(data.map_urban_icc_topo_offset_y)
        state.map_urban_icc_topo_zoom = check_undefined(data.map_urban_icc_topo_zoom)
        state.quote_travel_one_way_hours = check_undefined(data.quote_travel_one_way_hours)
        state.quote_travel_both_ways_hours = check_undefined(data.quote_travel_both_ways_hours)
        state.quote_travel_fees_per_hour = check_undefined(data.quote_travel_fees_per_hour)
        state.quote_car_expenses_one_way = check_undefined(data.quote_car_expenses_one_way)
        state.quote_car_expenses_both_ways = check_undefined(data.quote_car_expenses_both_ways)
        state.quote_total_travel_fees = check_undefined(data.quote_total_travel_fees)
        state.quote_area_average_unit_price = check_undefined(data.quote_area_average_unit_price)
        state.quote_base_fees = check_undefined(data.quote_base_fees)
        state.quote_excess_pct = check_undefined(data.quote_excess_pct)
        state.quote_base_price = check_undefined(data.quote_base_price)
        state.quote_base_price_coef = check_undefined(data.quote_base_price_coef)
        state.usage_type = check_undefined(data.usage_type)
        state.parking_spots_included_number = check_undefined(data.parking_spots_included_number)

    },
    [SET_APPRAISAL_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_APPRAISAL_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_APPRAISAL_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_APPRAISAL_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_APPRAISAL_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_APPRAISAL_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_APPRAISAL_APPRAISALDATE] (state, data) {
        state.appraisaldate = data
        state.dirty = true
    },
    [SET_APPRAISAL_VISITDATE] (state, data) {
        state.visitdate = data
        state.dirty = true
    },
    [SET_APPRAISAL_TECHNICIAN_VISITING] (state, data) {
        state.technician_visiting = data
        state.dirty = true
    },
    [SET_APPRAISAL_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_APPRAISAL_PURPOSE] (state, data) {
        state.purpose = data
        state.dirty = true
    },
    [SET_APPRAISAL_PURPOSE_NOTES] (state, data) {
        state.purpose_notes = data
        state.dirty = true
    },
    [SET_APPRAISAL_TYPE] (state, data) {
        state.type = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_CADASTRAL_DATA] (state, data) {
        state.checks_cadastral_data = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_CONSERVATION_STATUS] (state, data) {
        state.checks_conservation_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE] (state, data) {
        state.checks_expropriation_procedure = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN] (state, data) {
        state.checks_expropriation_plan = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING] (state, data) {
        state.checks_expropriation_admin_ruling = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE] (state, data) {
        state.checks_expropriation_file = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_INTERIOR_VISIT] (state, data) {
        state.checks_interior_visit = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_OCCUPANCY] (state, data) {
        state.checks_occupancy = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_OTHER] (state, data) {
        state.checks_other = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_REGISTRY_DATA] (state, data) {
        state.checks_registry_data = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_SERVITUDES] (state, data) {
        state.checks_servitudes = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_SUBSIDY_STATUS] (state, data) {
        state.checks_subsidy_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_CHECKS_URBAN_PLANNING] (state, data) {
        state.checks_urban_planning = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_APPROVED_PROJECT] (state, data) {
        state.docs_approved_project = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_CADASTRAL_DATA] (state, data) {
        state.docs_cadastral_data = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE] (state, data) {
        state.docs_construction_license = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE] (state, data) {
        state.docs_construction_last_certificate = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT] (state, data) {
        state.docs_construction_contract = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_OCCUPANCY_STATUS] (state, data) {
        state.docs_occupancy_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_OTHER] (state, data) {
        state.docs_other = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT] (state, data) {
        state.docs_photographic_report = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_PROPERTY_SKETCH] (state, data) {
        state.docs_property_sketch = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_PROPERTY_TITLES] (state, data) {
        state.docs_property_titles = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_SITUATION_PLAN] (state, data) {
        state.docs_situation_plan = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_SUBSIDY_STATUS] (state, data) {
        state.docs_subsidy_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_TENYEAR_INSURANCE] (state, data) {
        state.docs_tenyear_insurance = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOCS_URBAN_PLAN] (state, data) {
        state.docs_urban_plan = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_AREA] (state, data) {
        state.adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LIFT] (state, data) {
        state.lift = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_AGE] (state, data) {
        state.adopted_age = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD] (state, data) {
        state.adopted_age_years_old = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROPERTY_TYPE] (state, data) {
        state.property_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD] (state, data) {
        state.quality_of_neighbourhood = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUALITY_OF_SITUATION] (state, data) {
        state.quality_of_situation = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUALITY_OF_CONSTRUCTION] (state, data) {
        state.quality_of_construction = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUALITY_OF_REALESTATE] (state, data) {
        state.quality_of_realestate = data
        state.dirty = true
    },
    [SET_APPRAISAL_CONSERVATION_STATUS] (state, data) {
        state.conservation_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_FLOOR_NUMBER] (state, data) {
        state.floor_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_MARKET_VALUE] (state, data) {
        state.market_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_MARKET_UNIT_VALUE] (state, data) {
        state.market_unit_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_BEC_PRICE] (state, data) {
        state.bec_price = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADJUSTED_BEC_PRICE] (state, data) {
        state.adjusted_bec_price = data
        state.dirty = true
    },
    [SET_APPRAISAL_BC] (state, data) {
        state.bc = data
        state.dirty = true
    },
    [SET_APPRAISAL_BC_PCT] (state, data) {
        state.bc_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_GC] (state, data) {
        state.gc = data
        state.dirty = true
    },
    [SET_APPRAISAL_GC_PCT] (state, data) {
        state.gc_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_BC_AND_GC_PCT] (state, data) {
        state.bc_and_gc_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_BC_AND_GC] (state, data) {
        state.bc_and_gc = data
        state.dirty = true
    },
    [SET_APPRAISAL_CC] (state, data) {
        state.cc = data
        state.dirty = true
    },
    [SET_APPRAISAL_CC_PCT] (state, data) {
        state.cc_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_HTL] (state, data) {
        state.htl = data
        state.dirty = true
    },
    [SET_APPRAISAL_HTL_PCT] (state, data) {
        state.htl_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_INR] (state, data) {
        state.inr = data
        state.dirty = true
    },
    [SET_APPRAISAL_INR_PCT] (state, data) {
        state.inr_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_GA] (state, data) {
        state.ga = data
        state.dirty = true
    },
    [SET_APPRAISAL_GA_PCT] (state, data) {
        state.ga_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_GPD] (state, data) {
        state.gpd = data
        state.dirty = true
    },
    [SET_APPRAISAL_GPD_PCT] (state, data) {
        state.gpd_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCT] (state, data) {
        state.oct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCT_PCT] (state, data) {
        state.oct_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_GP] (state, data) {
        state.gp = data
        state.dirty = true
    },
    [SET_APPRAISAL_GP_PCT] (state, data) {
        state.gp_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_CC_AND_GP] (state, data) {
        state.cc_and_gp = data
        state.dirty = true
    },
    [SET_APPRAISAL_F] (state, data) {
        state.f = data
        state.dirty = true
    },
    [SET_APPRAISAL_CRB] (state, data) {
        state.crb = data
        state.dirty = true
    },
    [SET_APPRAISAL_CCD] (state, data) {
        state.ccd = data
        state.dirty = true
    },
    [SET_APPRAISAL_TLR_PCT] (state, data) {
        state.tlr_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_PR_PCT] (state, data) {
        state.pr_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_AM_COEF] (state, data) {
        state.am_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_B1_PCT] (state, data) {
        state.b1_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_B2_PCT] (state, data) {
        state.b2_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_B_PCT] (state, data) {
        state.b_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_B_REMAINING_PCT] (state, data) {
        state.b_remaining_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_I_PCT] (state, data) {
        state.i_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_TENANT_AGE_YEARS] (state, data) {
        state.tenant_age_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS] (state, data) {
        state.tenant_life_expectancy_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS] (state, data) {
        state.tenant_remaining_life_expectancy_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_BOOLEAN] (state, data) {
        state.cession_boolean = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME] (state, data) {
        state.cession_gross_monthly_income = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME] (state, data) {
        state.cession_gross_yearly_income = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_NET_YEARLY_INCOME] (state, data) {
        state.cession_net_yearly_income = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS] (state, data) {
        state.cession_contract_period_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS] (state, data) {
        state.cession_contract_remaining_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_CESSION_CONTRACT_START_DATE] (state, data) {
        state.cession_contract_start_date = data
        state.dirty = true
    },
    [SET_APPRAISAL_LANDLORD_EXPENSES_PCT] (state, data) {
        state.landlord_expenses_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_REDUCTION_PCT] (state, data) {
        state.reduction_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADJUSTMENT_COEF] (state, data) {
        state.adjustment_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS] (state, data) {
        state.usufructuary_age_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_USEFUL_LIFE_YEARS] (state, data) {
        state.useful_life_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS] (state, data) {
        state.remaining_useful_life_years = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAX_LEGAL_PRICE] (state, data) {
        state.max_legal_price = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAX_LEGAL_AREA] (state, data) {
        state.max_legal_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_MATERIAL_EXECUTION_COST] (state, data) {
        state.material_execution_cost = data
        state.dirty = true
    },
    [SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST] (state, data) {
        state.deprecated_material_execution_cost = data
        state.dirty = true
    },
    [SET_APPRAISAL_MEC_ADJUSTMENT_COEF] (state, data) {
        state.mec_adjustment_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST] (state, data) {
        state.adopted_material_execution_cost = data
        state.dirty = true
    },
    [SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT] (state, data) {
        state.physical_depreciation_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT] (state, data) {
        state.functional_depreciation_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_TOTAL_DEPRECIATION_PCT] (state, data) {
        state.total_depreciation_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT] (state, data) {
        state.total_construction_progress_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_MARKET_VALUE] (state, data) {
        state.adopted_market_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE] (state, data) {
        state.adopted_market_unit_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT] (state, data) {
        state.market_value_appraiser_adjustment_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_DEPRECATED_LAND_AND_CC] (state, data) {
        state.deprecated_land_and_cc = data
        state.dirty = true
    },
    [SET_APPRAISAL_FINISHED_REALESTATE_CRN] (state, data) {
        state.finished_realestate_crn = data
        state.dirty = true
    },
    [SET_APPRAISAL_CCR] (state, data) {
        state.ccr = data
        state.dirty = true
    },
    [SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST] (state, data) {
        state.executed_construction_cost = data
        state.dirty = true
    },
    [SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN] (state, data) {
        state.under_construction_realestate_crn = data
        state.dirty = true
    },
    [SET_APPRAISAL_K] (state, data) {
        state.k = data
        state.dirty = true
    },
    [SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE] (state, data) {
        state.repercussion_method_land_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE] (state, data) {
        state.cost_method_construction_crb_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE] (state, data) {
        state.cost_method_construction_crn_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE] (state, data) {
        state.cost_method_realestate_crb_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE] (state, data) {
        state.cost_method_realestate_crn_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMPARISON_METHOD] (state, data) {
        state.comparison_method = data
        state.dirty = true
    },
    [SET_APPRAISAL_ADJUSTED_MARKET_VALUE] (state, data) {
        state.adjusted_market_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAX_LEGAL_METHOD] (state, data) {
        state.max_legal_method = data
        state.dirty = true
    },
    [SET_APPRAISAL_VC] (state, data) {
        state.vc = data
        state.dirty = true
    },
    [SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD] (state, data) {
        state.income_perpetuity_update_method = data
        state.dirty = true
    },
    [SET_APPRAISAL_U] (state, data) {
        state.u = data
        state.dirty = true
    },
    [SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT] (state, data) {
        state.residual_depreciation_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_RESIDUAL_DEPRECIATION] (state, data) {
        state.residual_depreciation = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE] (state, data) {
        state.realestate_residual_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_I] (state, data) {
        state.i = data
        state.dirty = true
    },
    [SET_APPRAISAL_NP] (state, data) {
        state.np = data
        state.dirty = true
    },
    [SET_APPRAISAL_COEF_1] (state, data) {
        state.coef_1 = data
        state.dirty = true
    },
    [SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE] (state, data) {
        state.current_future_income_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_COEF_2] (state, data) {
        state.coef_2 = data
        state.dirty = true
    },
    [SET_APPRAISAL_UPDATED_REVERSION_VALUE] (state, data) {
        state.updated_reversion_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_UPDATE_VALUE] (state, data) {
        state.update_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_INSURANCE_VALUE] (state, data) {
        state.insurance_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_VU_COEF] (state, data) {
        state.vu_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_USUFRUCT_VALUE] (state, data) {
        state.usufruct_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_BARE_OWNERSHIP_VALUE] (state, data) {
        state.bare_ownership_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE] (state, data) {
        state.realestate_total_adopted_value = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD] (state, data) {
        state.realestate_adopted_appraisal_method = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_ID] (state, data) {
        state.realestate_id = data
        state.dirty = true
    },
    [SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN] (state, data) {
        state.right_of_use_boolean = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROTECTION_BOOLEAN] (state, data) {
        state.protection_boolean = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROTECTION_TYPE] (state, data) {
        state.protection_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROTECTION_REGIME] (state, data) {
        state.protection_regime = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROTECTION_ZONE] (state, data) {
        state.protection_zone = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_TYPE] (state, data) {
        state.urban_planning_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_FILE] (state, data) {
        state.urban_planning_file = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION] (state, data) {
        state.urban_planning_council_qualification = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION] (state, data) {
        state.urban_planning_council_qualification_description = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION] (state, data) {
        state.urban_planning_council_classification = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION] (state, data) {
        state.urban_planning_council_classification_description = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION] (state, data) {
        state.urban_planning_regional_qualification = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION] (state, data) {
        state.urban_planning_regional_qualification_description = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION] (state, data) {
        state.urban_planning_regional_classification = data
        state.dirty = true
    },
    [SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION] (state, data) {
        state.urban_planning_regional_classification_description = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS] (state, data) {
        state.map_urban_muc_land_colors = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL] (state, data) {
        state.map_urban_muc_council_qual = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_ICC_TOPO] (state, data) {
        state.map_urban_icc_topo = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_REGISTRY_AREA] (state, data) {
        state.land_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_CADASTRAL_AREA] (state, data) {
        state.land_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_CHECKED_AREA] (state, data) {
        state.land_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_ADOPTED_AREA] (state, data) {
        state.land_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_paving_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_sewage_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_public_lighting_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_electricity_supply_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_piped_gas_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_telephone_service_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_gardened_areas_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_total_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST] (state, data) {
        state.land_infrastructure_repercussion_cost = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT] (state, data) {
        state.land_infrastructure_pending_investment = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING] (state, data) {
        state.land_infrastructure_paving = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE] (state, data) {
        state.land_infrastructure_sewage = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING] (state, data) {
        state.land_infrastructure_public_lighting = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY] (state, data) {
        state.land_infrastructure_electricity_supply = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS] (state, data) {
        state.land_infrastructure_piped_gas = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE] (state, data) {
        state.land_infrastructure_telephone_service = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS] (state, data) {
        state.land_infrastructure_gardened_areas = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW] (state, data) {
        state.land_is_plot_according_to_law = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_AREA_NOTES] (state, data) {
        state.land_area_notes = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES] (state, data) {
        state.land_infrastructure_notes = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS] (state, data) {
        state.land_infrastructure_conservation_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT] (state, data) {
        state.land_infrastructure_water_supply_execution_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY] (state, data) {
        state.land_infrastructure_water_supply = data
        state.dirty = true
    },
    [SET_APPRAISAL_PLOT_OCCUPATION] (state, data) {
        state.plot_occupation = data
        state.dirty = true
    },
    [SET_APPRAISAL_PLOT_FREE_AREA_USAGE] (state, data) {
        state.plot_free_area_usage = data
        state.dirty = true
    },
    [SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND] (state, data) {
        state.floors_number_underground = data
        state.dirty = true
    },
    [SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND] (state, data) {
        state.floors_number_overground = data
        state.dirty = true
    },
    [SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER] (state, data) {
        state.parking_slots_included_in_appraisal_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENTRANCE_HALL] (state, data) {
        state.entrance_hall = data
        state.dirty = true
    },
    [SET_APPRAISAL_DOORMAN_SPACE] (state, data) {
        state.doorman_space = data
        state.dirty = true
    },
    [SET_APPRAISAL_STAIRCASE] (state, data) {
        state.staircase = data
        state.dirty = true
    },
    [SET_APPRAISAL_SWIMMING_POOL] (state, data) {
        state.swimming_pool = data
        state.dirty = true
    },
    [SET_APPRAISAL_GARDENED_AREAS] (state, data) {
        state.gardened_areas = data
        state.dirty = true
    },
    [SET_APPRAISAL_SPORTS_FACILITIES] (state, data) {
        state.sports_facilities = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMUNITY_ROOM] (state, data) {
        state.community_room = data
        state.dirty = true
    },
    [SET_APPRAISAL_STORAGE_ROOM] (state, data) {
        state.storage_room = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMUNITY_PARKING] (state, data) {
        state.community_parking = data
        state.dirty = true
    },
    [SET_APPRAISAL_FACILITIES_OTHERS] (state, data) {
        state.facilities_others = data
        state.dirty = true
    },
    [SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND] (state, data) {
        state.floors_usage_underground = data
        state.dirty = true
    },
    [SET_APPRAISAL_FLOORS_USAGE_OVERGROUND] (state, data) {
        state.floors_usage_overground = data
        state.dirty = true
    },
    [SET_APPRAISAL_GROUNDFLOOR_USAGE] (state, data) {
        state.groundfloor_usage = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMUNICATIONS_AIRPORT] (state, data) {
        state.communications_airport = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMUNICATIONS_HARBOUR] (state, data) {
        state.communications_harbour = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMUNICATIONS_TRAIN] (state, data) {
        state.communications_train = data
        state.dirty = true
    },
    [SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND] (state, data) {
        state.public_transport_urban_underground = data
        state.dirty = true
    },
    [SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN] (state, data) {
        state.public_transport_interurban = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES] (state, data) {
        state.surrounding_facilities_notes = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE] (state, data) {
        state.surrounding_territorial_feature = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_INCOME_LEVEL] (state, data) {
        state.surrounding_income_level = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE] (state, data) {
        state.surrounding_homogeneity_feature = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_MAIN_USES] (state, data) {
        state.surrounding_main_uses = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_DENSITY] (state, data) {
        state.surrounding_density = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_ACCESSIBILITY] (state, data) {
        state.surrounding_accessibility = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE] (state, data) {
        state.surrounding_consolidation_degree = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE] (state, data) {
        state.surrounding_occupation_degree = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED] (state, data) {
        state.surrounding_evolution_speed = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_AVERAGE_AGE] (state, data) {
        state.surrounding_average_age = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS] (state, data) {
        state.surrounding_conservation_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES] (state, data) {
        state.surrounding_commercial_facilities = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES] (state, data) {
        state.surrounding_educational_facilities = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING] (state, data) {
        state.surrounding_public_parking = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE] (state, data) {
        state.surrounding_medical_assistance = data
        state.dirty = true
    },
    [SET_APPRAISAL_SURROUNDING_LEISURE] (state, data) {
        state.surrounding_leisure = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_USAGE] (state, data) {
        state.cadastral_usage = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_FLOOR] (state, data) {
        state.cadastral_floor = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_DOOR] (state, data) {
        state.cadastral_door = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_BLOCK] (state, data) {
        state.cadastral_block = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_STAIRCASE] (state, data) {
        state.cadastral_staircase = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_NAME] (state, data) {
        state.registry_name = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_SECTION] (state, data) {
        state.registry_section = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_VOLUME] (state, data) {
        state.registry_volume = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_BOOK] (state, data) {
        state.registry_book = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_PAGE] (state, data) {
        state.registry_page = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER] (state, data) {
        state.registry_real_estate_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_IDUFIR] (state, data) {
        state.registry_idufir = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_OWNER] (state, data) {
        state.registry_owner = data
        state.dirty = true
    },
    [SET_APPRAISAL_REGISTRY_PROPERTY_COEF] (state, data) {
        state.registry_property_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_NET_CADASTRAL_AREA] (state, data) {
        state.net_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_NET_REGISTRY_AREA] (state, data) {
        state.net_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_NET_CHECKED_AREA] (state, data) {
        state.net_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_NET_ADOPTED_AREA] (state, data) {
        state.net_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA] (state, data) {
        state.enclosed_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENCLOSED_REGISTRY_AREA] (state, data) {
        state.enclosed_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENCLOSED_CHECKED_AREA] (state, data) {
        state.enclosed_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENCLOSED_ADOPTED_AREA] (state, data) {
        state.enclosed_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA] (state, data) {
        state.covered_terraces_total_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA] (state, data) {
        state.covered_terraces_total_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA] (state, data) {
        state.covered_terraces_total_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA] (state, data) {
        state.covered_terraces_total_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA] (state, data) {
        state.uncovered_terraces_total_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA] (state, data) {
        state.uncovered_terraces_total_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA] (state, data) {
        state.uncovered_terraces_total_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA] (state, data) {
        state.uncovered_terraces_total_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_CADASTRAL_AREA] (state, data) {
        state.built_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_REGISTRY_AREA] (state, data) {
        state.built_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_CHECKED_AREA] (state, data) {
        state.built_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_ADOPTED_AREA] (state, data) {
        state.built_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA] (state, data) {
        state.common_elements_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA] (state, data) {
        state.common_elements_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA] (state, data) {
        state.common_elements_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA] (state, data) {
        state.common_elements_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA] (state, data) {
        state.built_plus_common_elements_cadastral_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA] (state, data) {
        state.built_plus_common_elements_registry_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA] (state, data) {
        state.built_plus_common_elements_checked_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA] (state, data) {
        state.built_plus_common_elements_adopted_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BATHROOMS_NUMBER] (state, data) {
        state.bathrooms_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_BEDROOMS_NUMBER] (state, data) {
        state.bedrooms_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_NET_SELECTED_AREA] (state, data) {
        state.net_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_ENCLOSED_SELECTED_AREA] (state, data) {
        state.enclosed_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA] (state, data) {
        state.covered_outdoors_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_SELECTED_AREA] (state, data) {
        state.built_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA] (state, data) {
        state.common_elements_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA] (state, data) {
        state.built_plus_common_elements_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAND_SELECTED_AREA] (state, data) {
        state.land_selected_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER] (state, data) {
        state.realestate_rooms_to_exterior_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING] (state, data) {
        state.realestate_day_night_zoning = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER] (state, data) {
        state.realestate_systems_door_opener = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS] (state, data) {
        state.realestate_systems_fitted_cupboards = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_GAS] (state, data) {
        state.realestate_systems_gas = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS] (state, data) {
        state.realestate_systems_sanitary_fittings = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS] (state, data) {
        state.realestate_systems_taps = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER] (state, data) {
        state.realestate_systems_hot_water = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING] (state, data) {
        state.realestate_systems_heating = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING] (state, data) {
        state.realestate_systems_air_conditioning = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_TV] (state, data) {
        state.realestate_systems_tv = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE] (state, data) {
        state.realestate_systems_telephone = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION] (state, data) {
        state.realestate_systems_fire_prevention = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION] (state, data) {
        state.realestate_systems_intrusion_prevention = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_FOUNDATION] (state, data) {
        state.realestate_foundation = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_STRUCTURE] (state, data) {
        state.realestate_structure = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_ROOF] (state, data) {
        state.realestate_roof = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES] (state, data) {
        state.realestate_external_enclosures = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INSULATION] (state, data) {
        state.realestate_insulation = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY] (state, data) {
        state.realestate_external_carpentry = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_GLAZING] (state, data) {
        state.realestate_glazing = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING] (state, data) {
        state.realestate_interior_paving_living = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR] (state, data) {
        state.realestate_interior_paving_corridor = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM] (state, data) {
        state.realestate_interior_paving_bedroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN] (state, data) {
        state.realestate_interior_paving_kitchen = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM] (state, data) {
        state.realestate_interior_paving_bathroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY] (state, data) {
        state.realestate_interior_paving_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING] (state, data) {
        state.realestate_interior_walls_living = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR] (state, data) {
        state.realestate_interior_walls_corridor = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM] (state, data) {
        state.realestate_interior_walls_bedroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN] (state, data) {
        state.realestate_interior_walls_kitchen = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM] (state, data) {
        state.realestate_interior_walls_bathroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY] (state, data) {
        state.realestate_interior_walls_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING] (state, data) {
        state.realestate_interior_ceilings_living = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR] (state, data) {
        state.realestate_interior_ceilings_corridor = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM] (state, data) {
        state.realestate_interior_ceilings_bedroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN] (state, data) {
        state.realestate_interior_ceilings_kitchen = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM] (state, data) {
        state.realestate_interior_ceilings_bathroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY] (state, data) {
        state.realestate_interior_ceilings_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING] (state, data) {
        state.realestate_interior_carpentry_living = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR] (state, data) {
        state.realestate_interior_carpentry_corridor = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM] (state, data) {
        state.realestate_interior_carpentry_bedroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN] (state, data) {
        state.realestate_interior_carpentry_kitchen = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM] (state, data) {
        state.realestate_interior_carpentry_bathroom = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY] (state, data) {
        state.realestate_interior_carpentry_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION] (state, data) {
        state.realestate_main_orientation = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_MAIN_VIEWS] (state, data) {
        state.realestate_main_views = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY] (state, data) {
        state.realestate_windows_size_and_quantity = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_NOISE_FACADE] (state, data) {
        state.realestate_noise_facade = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY] (state, data) {
        state.realestate_systems_sanitary_fittings_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY] (state, data) {
        state.realestate_systems_taps_quality = data
        state.dirty = true
    },
    [SET_APPRAISAL_BEC_ADJUSTMENT_COEF] (state, data) {
        state.bec_adjustment_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_BEC_PROPERTY_TYPE] (state, data) {
        state.bec_property_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_BEC_NUMBER] (state, data) {
        state.bec_number = data
        state.dirty = true
    },
    [SET_APPRAISAL_CONSTRUCTION_STATUS] (state, data) {
        state.construction_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT] (state, data) {
        state.expenses_and_industrial_benefit_bec_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_CONSTRUCTION_COST_NOTES] (state, data) {
        state.construction_cost_notes = data
        state.dirty = true
    },
    [SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR] (state, data) {
        state.cadastral_construction_year = data
        state.dirty = true
    },
    [SET_APPRAISAL_CONSTRUCTION_YEAR] (state, data) {
        state.construction_year = data
        state.dirty = true
    },
    [SET_APPRAISAL_LAST_RENOVATION_YEAR] (state, data) {
        state.last_renovation_year = data
        state.dirty = true
    },
    [SET_APPRAISAL_NUCLEUS_POPULATION] (state, data) {
        state.nucleus_population = data
        state.dirty = true
    },
    [SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY] (state, data) {
        state.nucleus_population_density = data
        state.dirty = true
    },
    [SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH] (state, data) {
        state.nucleus_population_growth = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT] (state, data) {
        state.occupation_agriculture_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT] (state, data) {
        state.occupation_industry_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT] (state, data) {
        state.occupation_construction_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_SERVICES_PCT] (state, data) {
        state.occupation_services_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_TOTAL_PCT] (state, data) {
        state.occupation_total_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_NUCLEUS_TYPE] (state, data) {
        state.nucleus_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPATION_DESCRIPTION] (state, data) {
        state.occupation_description = data
        state.dirty = true
    },
    [SET_APPRAISAL_NUCLEUS_AREA] (state, data) {
        state.nucleus_area = data
        state.dirty = true
    },
    [SET_APPRAISAL_PROPERTY_TITLE] (state, data) {
        state.property_title = data
        state.dirty = true
    },
    [SET_APPRAISAL_USAGE_ASSIGNED] (state, data) {
        state.usage_assigned = data
        state.dirty = true
    },
    [SET_APPRAISAL_INSPECTION_REALIZED] (state, data) {
        state.inspection_realized = data
        state.dirty = true
    },
    [SET_APPRAISAL_ECONOMICAL_ACTIVITY] (state, data) {
        state.economical_activity = data
        state.dirty = true
    },
    [SET_APPRAISAL_OCCUPANCY_STATUS] (state, data) {
        state.occupancy_status = data
        state.dirty = true
    },
    [SET_APPRAISAL_MARKETSTUDY_ID] (state, data) {
        state.marketstudy_id = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X] (state, data) {
        state.map_urban_muc_land_colors_offset_x = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y] (state, data) {
        state.map_urban_muc_land_colors_offset_y = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM] (state, data) {
        state.map_urban_muc_land_colors_zoom = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X] (state, data) {
        state.map_urban_muc_council_qual_offset_x = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y] (state, data) {
        state.map_urban_muc_council_qual_offset_y = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM] (state, data) {
        state.map_urban_muc_council_qual_zoom = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X] (state, data) {
        state.map_urban_icc_topo_offset_x = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y] (state, data) {
        state.map_urban_icc_topo_offset_y = data
        state.dirty = true
    },
    [SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM] (state, data) {
        state.map_urban_icc_topo_zoom = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS] (state, data) {
        state.quote_travel_one_way_hours = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS] (state, data) {
        state.quote_travel_both_ways_hours = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR] (state, data) {
        state.quote_travel_fees_per_hour = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY] (state, data) {
        state.quote_car_expenses_one_way = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS] (state, data) {
        state.quote_car_expenses_both_ways = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES] (state, data) {
        state.quote_total_travel_fees = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE] (state, data) {
        state.quote_area_average_unit_price = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_BASE_FEES] (state, data) {
        state.quote_base_fees = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_EXCESS_PCT] (state, data) {
        state.quote_excess_pct = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_BASE_PRICE] (state, data) {
        state.quote_base_price = data
        state.dirty = true
    },
    [SET_APPRAISAL_QUOTE_BASE_PRICE_COEF] (state, data) {
        state.quote_base_price_coef = data
        state.dirty = true
    },
    [SET_APPRAISAL_USAGE_TYPE] (state, data) {
        state.usage_type = data
        state.dirty = true
    },
    [SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER] (state, data) {
        state.parking_spots_included_number = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

function roundToTwo (num) {
    return +(Math.round(num + 'e+2') + 'e-2')
}

const getters = {

    appraisal: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/appraisal/appraisal.js